export default {
  "nav": {
    "feed": "Лента",
    "map": "Карта",
    "discover": "Vibes",
    "plans": "Планы",
    "messages": "Чат",
    "profile": "Профиль"
  },
  "common": {
    "back": "Назад",
    "cancel": "Отмена",
    "save": "Сохранить",
    "saving": "Сохранение...",
    "edit": "Править",
    "delete": "Удалить",
    "remove": "Удалить из группы",
    "refresh": "Обновить",
    "error": "Ошибка",
    "loading": "Загрузка...",
    "tryAgain": "Пожалуйста, попробуйте еще раз.",
    "clear": "Очистить",
    "enable": "Включить",
    "tapToRetry": "Нажмите, чтобы повторить попытку.",
    "somethingWentWrong": "Что-то пошло не так.",
    "comingSoon": "СКОРО",
    "send": "Отправить",
    "ok": "ОК",
    "gotIt": "Понятно",
    "couldNotOpenLink": "Не удалось открыть ссылку.",
    "done": "Готово",
    "retry": "Повторить",
    "later": "Позже",
    "notNow": "Не сейчас",
    "openSettings": "Открыть настройки",
    "loadingTonyte": "Загрузка Tonyte…",
    "findingYourVibe": "Ищем твой вайб…",
    "almostThere": "Почти готово…",
    "stillGettingThingsReady": "Мы всё ещё готовим…",
    "profileLoadErrorTitle": "Не удалось загрузить профиль",
    "profileLoadErrorMessage": "Проверьте подключение и повторите попытку.",
    "continue": "Продолжить",
    "unknown": "Неизвестно",
    "unknownError": "Неизвестная ошибка.",
    "user": "пользователь",
    "sharedOnTonyte": "{name} на Tonyte"
  },
  "auth": {
    "signInRequired": "Требуется вход",
    "signInToUseFeature": "Войдите, чтобы использовать эту функцию.",
    "emailAlreadyInUse": "Учетная запись с этим адресом электронной почты уже существует. Вместо этого войдите в систему.",
    "invalidEmail": "Введите действительный адрес электронной почты.",
    "invalidCredentials": "Адрес электронной почты или пароль неверны.",
    "weakPassword": "Используйте пароль длиной не менее 6 символов.",
    "methodNotEnabled": "Этот метод входа еще не включен.",
    "networkError": "Ошибка сети. Проверьте подключение и повторите попытку.",
    "signInFailed": "Не удалось войти в систему. Пожалуйста, попробуйте еще раз.",
    "notSignedIn": "Вход не выполнен.",
    "googleSignInUnavailable": "Вход в Google недоступен в этой сборке. Пересоберите приложение после установки собственных зависимостей.",
    "googleSignInCancelled": "Вход в Google был отменен.",
    "googleMissingIdToken": "При входе в Google не возвращался токен идентификатора.",
    "appleSignInUnavailable": "Вход в систему Apple недоступен на этом устройстве.",
    "appleMissingIdentityToken": "При входе в систему Apple не возвращался идентификационный токен.",
    "appleSignInCancelled": "Вход в Apple был отменен."
  },
  "verifyEmail": {
    "title": "Подтвердите ваш email",
    "subtitle": "Мы отправили ссылку для подтверждения на",
    "instructions": "Перейдите по ссылке в письме, затем вернитесь сюда и нажмите «Проверить снова».",
    "resend": "Отправить письмо повторно",
    "resendCooldown": "Повторная отправка через {count} с",
    "resendSuccess": "Письмо для подтверждения отправлено.",
    "resendFailure": "Не удалось отправить письмо для подтверждения. Попробуйте еще раз.",
    "resendRateLimited": "Подождите немного, прежде чем запрашивать новое письмо.",
    "checkAgain": "Проверить снова",
    "checking": "Проверка…",
    "stillNotVerified": "Еще не подтверждено",
    "stillNotVerifiedMessage": "Мы пока не видим подтвержденный email для этого аккаунта. Проверьте почту (и папку со спамом) и попробуйте снова.",
    "verifiedSuccess": "Email подтвержден! Теперь у вас есть полный доступ.",
    "continueBrowsing": "Продолжить просмотр событий и карты",
    "logout": "Выйти / сменить аккаунт",
    "limitedAccessBanner": "Подтвердите email, чтобы открыть Vibe, планы, чат и другое.",
    "limitedAccessBannerAction": "Подтвердить сейчас",
    "gateTitle": "Сначала подтвердите email",
    "gateMessage": "Эта функция станет доступна после подтверждения вашего email.",
    "gateAction": "Подтвердить сейчас"
  },
  "resetPassword": {
    "title": "Сброс пароля",
    "subtitle": "Выберите новый пароль для аккаунта Tonyte.",
    "expiredLink": "Срок действия ссылки истёк. Запросите новую в Tonyte.",
    "invalidLink": "Ссылка недействительна или уже была использована.",
    "weakPassword": "Пароль должен содержать не менее 6 символов.",
    "networkError": "Ошибка сети. Проверьте подключение и повторите попытку.",
    "verifyFailed": "Не удалось проверить ссылку. Запросите новую.",
    "missingCode": "В ссылке отсутствует код подтверждения.",
    "mismatch": "Пароли не совпадают.",
    "verifying": "Проверяем ссылку...",
    "updating": "Обновляем пароль...",
    "success": "Пароль успешно обновлён",
    "continueToLogin": "Перейти ко входу",
    "unavailable": "Ссылка недоступна",
    "resettingFor": "Сброс пароля для {email}",
    "newPassword": "Новый пароль",
    "minimumCharacters": "Не менее 6 символов",
    "confirmPassword": "Подтвердите пароль",
    "enterAgain": "Введите пароль ещё раз",
    "updatePassword": "Обновить пароль"
  },
  "vibesList": {
    "eyebrow": "ТВОИ ЛЮДИ",
    "title": "Vibes",
    "search": "Поиск среди ваших vibes",
    "noMatches": "Подходящих vibes нет",
    "noMatchesSub": "Ищите по имени, нику, городу или университету.",
    "empty": "Vibes пока нет",
    "emptySub": "Здесь появятся люди, с которыми вы познакомитесь через чаты и vibes.",
    "openDailyVibes": "Открыть Daily Vibes",
    "removeTitle": "Удалить эту vibe?",
    "removeBody": "Пользователь исчезнет из списка Vibes, но история чата сохранится.",
    "removeFailed": "Не удалось удалить эту vibe.",
    "message": "Сообщение",
    "viewProfile": "Открыть профиль",
    "community": "Сообщество Tonyte",
    "recentlyActive": "Недавно в сети",
    "activeMinutes": "В сети {count} мин назад",
    "activeHours": "В сети {count} ч назад",
    "activeDays": "В сети {count} дн назад",
    "removeAccessibility": "Удалить {name} из Vibes",
    "removeSuccess": "{name} удалён из ваших Vibes"
  },
  "partner": {
    "profileSelectorTitle": "Выберите профиль партнёра",
    "profileSelectorBody": "Этот аккаунт управляет несколькими партнёрами.",
    "profileUnavailableTitle": "Профиль партнёра недоступен",
    "profileLoadFailed": "Не удалось проверить доступ партнёра. Попробуйте ещё раз — данные аккаунта не пострадают.",
    "profileLinkMissing": "Аккаунт партнёра активен, но к нему не привязан профиль партнёра. Обратитесь в поддержку Tonyte, чтобы восстановить доступ.",
    "publicProfileUnavailableBody": "Этот профиль партнёра сейчас недоступен.",
    "publicProfileLoadFailed": "Не удалось загрузить профиль. Проверьте подключение и попробуйте ещё раз.",
    "kicker": "Tonyte Partner",
    "tools": "Инструменты партнёра",
    "profile": "Профиль партнёра",
    "profileSub": "Управляйте отображением своей компании в Tonyte",
    "createEvent": "Создать событие",
    "createEventSub": "Опубликовать новое событие",
    "myEvents": "Мои события",
    "myEventsSub": "Просматривайте, редактируйте и удаляйте предстоящие и текущие события",
    "analytics": "Аналитика",
    "analyticsSub": "Открытия, отметки интереса и публикации",
    "notifications": "Уведомления",
    "notificationsSub": "Достижения и новости о ваших событиях",
    "noNotifications": "Уведомлений пока нет.",
    "totalTaps": "Всего открытий",
    "interestedTaps": "Отметки интереса",
    "shares": "Публикации",
    "byEvent": "По событиям",
    "noAnalytics": "Событий пока нет — опубликуйте первое, чтобы увидеть аналитику.",
    "untitledEvent": "Событие без названия",
    "taps": "открытий",
    "interested": "заинтересованы",
    "sharesLower": "публикаций",
    "createPassword": "Создайте пароль",
    "firstSignIn": "Это ваш первый вход — задайте новый пароль, чтобы продолжить.",
    "setPasswordContinue": "Задать пароль и продолжить",
    "setPasswordFailed": "Не удалось задать пароль. Повторите попытку.",
    "signOut": "Выйти",
    "notAssigned": "Еще не назначено",
    "categoryMissing": "Ваша категория партнера еще не присвоена. Свяжитесь с администратором Tonyte, чтобы настроить категорию вашей учетной записи.",
    "typeCommunity": "Сообщество",
    "typeOrganizer": "Организатор",
    "typeVenue": "Место проведения",
    "typeUniversity": "Университет",
    "typeStudentOrganization": "Студенческая организация",
    "businessName": "Название компании",
    "description": "Описание",
    "descriptionPlaceholder": "Расскажите людям, о чем вы",
    "website": "Веб-сайт",
    "instagram": "Инстаграм",
    "venueAddress": "Адрес места проведения",
    "venueAddressPlaceholder": "Улица, город, страна",
    "saveChanges": "Сохранить изменения",
    "viewTerms": "Посмотреть условия для партнеров",
    "requiredFields": "Необходимо указать название и описание компании.",
    "venueAddressRequired": "Требуется адрес места проведения.",
    "profileUpdated": "Профиль обновлен.",
    "profileSaveFailed": "Не удалось сохранить ваш профиль. Пожалуйста, попробуйте еще раз."
  },
  "editProfile": {
    "nameRequired": "Укажите имя",
    "addName": "Добавьте имя перед сохранением профиля.",
    "invalidDob": "Неверная дата рождения",
    "ageRequirement": "Tonyte доступен пользователям от {age} лет. Проверьте дату рождения.",
    "saveFailed": "Не удалось сохранить профиль",
    "name": "Имя *",
    "yourName": "Ваше имя",
    "bio": "О себе",
    "bioPlaceholder": "Расскажите сообществу немного о себе…",
    "city": "Город",
    "yourCity": "Ваш город",
    "country": "Страна",
    "yourCountry": "Ваша страна",
    "dateOfBirth": "Дата рождения",
    "personality": "Интересы",
    "selectedCount": "Выбрано {count}/30",
    "addCustom": "Добавить «{interest}»"
  },
  "waitingList": {
    "title": "Вы в списке ожидания",
    "badge": "РАННИЙ ДОСТУП",
    "headline": "Прекратите прокручивать.\nНачните выходить.",
    "supportingText": "Мы постепенно приглашаем новых участников, чтобы сообщество оставалось аутентичным, активным и безопасным.",
    "featureEventsTitle": "Найти события",
    "featureEventsBody": "Узнайте, что происходит вокруг вас.",
    "featurePlansTitle": "Создание планов",
    "featurePlansBody": "Создайте план и найдите людей, к которым можно присоединиться.",
    "featureVibeTitle": "Ежедневно Vibe",
    "featureVibeBody": "Ответьте на несколько вопросов и найдите совпадения с vibe.",
    "featureTogetherTitle": "Никогда не чувствуй себя одиноким",
    "featureTogetherBody": "Всегда находите, чем заняться и с кем это сделать.",
    "applicationReceived": "Заявка получена",
    "notificationText": "Мы сообщим вам, как только ваша учетная запись будет активирована.",
    "currentCity": "Текущий город",
    "footer": "Спасибо, что помогаете нам строить будущее социальных открытий.",
    "visitWebsite": "Посетите веб-сайт",
    "visitWebsiteSub": "Посмотрите, как работает Tonyte →"
  },
  "login": {
    "missingDetails": "Отсутствуют детали",
    "enterEmailPassword": "Введите свой адрес электронной почты и пароль.",
    "passwordTooShort": "Пароль слишком короткий.",
    "passwordMin": "Используйте не менее 6 символов.",
    "emailSignInFailed": "Не удалось выполнить аутентификацию по электронной почте.",
    "emailRequired": "Требуется адрес электронной почты",
    "enterResetEmail": "Введите свой адрес электронной почты, чтобы сбросить пароль.",
    "forgotPassword": "Забыли пароль?",
    "resetEmailSent": "Сбросить отправленное письмо",
    "resetEmailSentMessage": "Проверьте свой почтовый ящик на наличие ссылки для сброса пароля.",
    "passwordResetFailed": "Не удалось сбросить пароль.",
    "signInFailed": "Не удалось войти в систему",
    "appleSignInFailed": "Apple Не удалось войти в систему",
    "signInWithEmail": "Войдите с помощью электронной почты",
    "createYourAccount": "Создайте свою учетную запись",
    "signIn": "Войти",
    "create": "Зарегистрируйтесь",
    "createAccount": "Создать учетную запись",
    "email": "Электронная почта",
    "password": "Пароль",
    "findYour": "Найдите свой",
    "people": "человек",
    "plans": "планы",
    "tagline": "Прекратите прокручивать.\nНачните выходить.",
    "featurePeople": "Найдите своих людей",
    "featureEvents": "Посмотреть, что происходит",
    "featureAlone": "Никогда не выходите на улицу в одиночку.",
    "continueWithEmail": "Продолжить по электронной почте",
    "continueWithGoogle": "Продолжить с Google",
    "continueWithApple": "Продолжить с Apple",
    "legalPrefix": "Продолжая, вы соглашаетесь с нашими",
    "and": "и",
    "partnerSignInHint": "Вы партнёр Tonyte? Войдите выше с помощью ID партнёра или электронной почты."
  },
  "settings": {
    "title": "Настройки",
    "account": "Аккаунт",
    "appearance": "Оформление",
    "midnight": "Midnight",
    "daylight": "Daylight",
    "language": "Язык",
    "appLanguage": "Язык приложения",
    "languageSaved": "Язык сохранен.",
    "languageSaveError": "Не удалось сохранить язык.",
    "profileManagement": "Управление профилем",
    "profileCompleted": "Профиль завершен",
    "profileCompletedSub": "Ответы вашего профиля полностью заданы.",
    "editProfile": "Редактировать профиль",
    "editProfileAnswers": "Редактировать ответы профиля",
    "completeProfile": "Полный профиль",
    "notifications": "Уведомления",
    "pushNotifications": "Push-уведомления",
    "legal": "Юридическая информация",
    "privacyPolicy": "Политика конфиденциальности",
    "termsOfService": "Условия использования",
    "communityGuidelines": "Правила сообщества",
    "impressum": "Выходные данные",
    "partnerTerms": "Условия партнерства",
    "dataDeletionRequest": "Запрос на удаление данных",
    "about": "О",
    "tagline": "Знакомьтесь с людьми. Live ночь.",
    "accountPrivacy": "Конфиденциальность учетной записи",
    "blockedAccounts": "Заблокированные учетные записи",
    "faq": "FAQ",
    "helpFeedback": "Помощь и обратная связь",
    "verificationCenter": "Центр проверки",
    "savedTemplates": "Сохраненные шаблоны",
    "uploadedPlans": "Загруженные планы",
    "adminControls": "Элементы управления администратора",
    "dataDeletion": "Удаление данных",
    "logout": "Выход из системы",
    "deleteAccount": "Удалить учетную запись",
    "studentVerification": "Проверка учащихся",
    "vibeVerification": "Получите подтверждение Vibe",
    "tonyteSettings": "Настройки Tonyte",
    "version": "Версия {version}",
    "search": "Настройки поиска",
    "clearSearch": "Очистить поиск настроек",
    "profile": "Профиль",
    "partnerDashboard": "Панель управления партнером",
    "preferences": "Настройки",
    "privacyLegal": "Конфиденциальность и юридическая информация",
    "support": "Поддержка",
    "session": "Сеанс",
    "noSettings": "Настройки не найдены",
    "noSettingsSub": "Попробуйте другое ключевое слово.",
    "connectedEmail": "Подключенная электронная почта",
    "noEmail": "Электронная почта не подключена",
    "signInMethod": "Способ входа",
    "noSignInMethod": "Способ входа не найден.",
    "passwordLogin": "Вход по паролю включен",
    "connected": "{provider} подключен",
    "sendReset": "Отправить сброс пароля",
    "sending": "Отправка...",
    "unblock": "Разблокировать",
    "noBlocked": "Блокированных аккаунтов нет.",
    "searchFaq": "Часто задаваемые вопросы по поиску",
    "feedbackPlaceholder": "Расскажи нам, что у тебя на уме...",
    "feedbackEmail": "Контактный адрес электронной почты (необязательно)",
    "sendFeedback": "Отправить отзыв",
    "chatNotifications": "Сообщения и Vibes",
    "eventNotifications": "Планы",
    "eventRecommendationNotifications": "События и рекомендации",
    "partnerNotifications": "Партнёры, на которых я подписан",
    "verifiedStudent": "Проверенный студент",
    "verifiedStudentSub": "У вас есть полный доступ к мероприятиям только для студентов. Электронная почта вашего ученика остается конфиденциальной.",
    "checkInbox": "Проверьте свой почтовый ящик",
    "verificationSentPrefix": "Мы отправили ссылку для подтверждения на",
    "verificationSentSuffix": "Нажмите ссылку в этом письме, чтобы подтвердить право собственности.",
    "linkExpiry": "Срок действия ссылки истекает через 24 часа. Проверьте папку со спамом, если вы ее не видите.",
    "wrongEmail": "Неправильный адрес электронной почты?",
    "differentUniversityEmail": "Введите адрес электронной почты другого университета.",
    "resendVerification": "Повторно отправить письмо с подтверждением",
    "pendingReview": "Ожидается проверка",
    "pendingReviewSub": "Ваше право собственности на адрес электронной почты подтверждено. В ближайшее время администратор проверит ваше учреждение. Вы получите доступ после одобрения.",
    "verificationFailed": "Проверка не удалась",
    "studentFailedSub": "Ваша проверка не была одобрена. Пожалуйста, повторите попытку, указав действительный адрес электронной почты университета.",
    "universityEmail": "Электронная почта университета/студента",
    "universityEmailHelp": "Введите адрес электронной почты вашего университета. Мы отправим ссылку для подтверждения. Известные учреждения утверждаются мгновенно; другие рассматриваются в течение 24 часов.",
    "sendVerification": "Отправить письмо с подтверждением",
    "vibeVerifiedTitle": "Vibe Проверено",
    "vibeVerifiedSub": "В вашем профиле есть значок. Другие пользователи видят доверие, а не ваше селфи.",
    "privacy": "Конфиденциальность",
    "verificationPrivacy": "Ваше селфи для проверки проверяется вручную и удаляется после принятия решения о проверке. Средства проверки используются только для проверки вручную — Tonyte не использует распознавание лиц, биометрический анализ или автоматическую проверку.",
    "verificationPending": "Ожидается проверка",
    "verificationPendingSub": "Ваше селфи в очереди на проверку. После одобрения вы получите значок «Проверено» Vibe.",
    "submittingSelfie": "Отправка селфи…",
    "pendingAdminSub": "Ваш запрос будет оставаться на рассмотрении, пока администратор не рассмотрит его.",
    "selfieFailedSub": "Сделайте повторное селфи при хорошем освещении, с видимым лицом и жестом в кадре.",
    "tryAgain": "Попробуйте еще раз",
    "reviewSelfie": "Просмотрите свое селфи",
    "reviewSelfieSub": "Перед отправкой убедитесь, что ваше лицо и жест понятны.",
    "retake": "Повторная съемка",
    "submitReview": "Отправить на рассмотрение",
    "getVerified": "Получите подтверждение Vibe",
    "getVerifiedSub": "Сделайте одно быстрое селфи, чтобы показать, что вы настоящий человек, и завоевать доверие других. Ваше селфи для проверки проверяется вручную и удаляется после принятия решения о проверке.",
    "examplePose": "Пример позы",
    "matchPose": "Сделайте селфи, соответствующее позе выше.",
    "faceVisible": "Лицо ясно видно",
    "gestureVisible": "Жест руки виден",
    "goodLighting": "Хорошее освещение",
    "noFilters": "Никаких фильтров и скриншотов",
    "takeVerificationSelfie": "Сделайте селфи для подтверждения",
    "deleteAccountTitle": "Удалить учетную запись",
    "deleteAccountConfirm": "Вы уверены, что хотите навсегда удалить свою учетную запись Tonyte? Это действие невозможно отменить.",
    "deleteProfileInfo": "Ваш профиль больше не будет виден.",
    "deleteDataInfo": "Ваши частные чаты, совпадения, блокировки, пролистывания и данные учетной записи будут удалены.",
    "deletePlansInfo": "Ваши планы сообщества будут удалены. Публичные мероприятия не удаляются этим действием.",
    "confirmIdentity": "Подтвердите, что это вы",
    "reauthenticate": "В целях безопасности пройдите повторную аутентификацию с помощью {provider}, прежде чем мы удалим вашу учетную запись.",
    "enterPassword": "Введите свой пароль",
    "loadingUsers": "Загрузка пользователей…",
    "totalUsers": "{count} общее количество пользователей",
    "searchUsers": "Поиск пользователей...",
    "noEmailAvailable": "Электронная почта недоступна",
    "protectedAccount": "Защищенный аккаунт",
    "revoking": "Отмена…",
    "revokeVerified": "Отзыв Vibe проверен",
    "suspendAccountAction": "Заблокировать",
    "unsuspendAccountAction": "Разблокировать",
    "suspending": "Обновление…",
    "suspendAccountTitle": "Заблокировать аккаунт",
    "unsuspendAccountTitle": "Разблокировать аккаунт",
    "suspendAccountConfirm": "Заблокировать аккаунт {name}? Пользователь будет выведен из системы и не сможет войти снова до разблокировки.",
    "unsuspendAccountConfirm": "Разблокировать аккаунт {name}? Пользователь сможет снова войти в систему.",
    "suspendAccountSuccess": "{name} заблокирован.",
    "unsuspendAccountSuccess": "{name} разблокирован.",
    "suspendAccountFailed": "Не удалось заблокировать аккаунт. Попробуйте еще раз.",
    "unsuspendAccountFailed": "Не удалось разблокировать аккаунт. Попробуйте еще раз.",
    "cannotSuspendSelf": "Вы не можете заблокировать свой собственный аккаунт.",
    "deleteAccountAction": "Удалить аккаунт",
    "deletingAccount": "Удаление…",
    "deleteAccountTitle": "Удалить аккаунт",
    "deleteAccountConfirm1": "Навсегда удалить {name} ({email})? Аккаунт будет удален безвозвратно, отменить это действие нельзя.",
    "deleteAccountFinalTitle": "Вы абсолютно уверены?",
    "deleteAccountFinalBody": "Это навсегда удалит аккаунт из Firebase Authentication и Tonyte. Это действие нельзя отменить.",
    "deleteAccountFinalAction": "Удалить навсегда",
    "deleteAccountSuccess": "{name} был безвозвратно удален.",
    "deleteAccountFailed": "Не удалось удалить этот аккаунт. Попробуйте еще раз.",
    "cannotDeleteSelf": "Вы не можете удалить свой собственный аккаунт.",
    "cannotDeleteAdmin": "Администраторы не могут удалять другие аккаунты администраторов.",
    "noUsers": "Пользователи не найдены",
    "noPendingRequests": "Нет ожидающих запросов",
    "requestedEmail": "Запрошенный адрес электронной почты",
    "domain": "Домен",
    "requested": "Запрошено",
    "emailOwnership": "Адрес электронной почты владельца",
    "confirmed": "Подтверждено",
    "notConfirmed": "Не подтверждено",
    "accept": "Принять",
    "noPendingFace": "Нет ожидающих запросов на определение лица",
    "noAccountEmail": "Нет адреса электронной почты учетной записи",
    "shakaSelfie": "Селфи Шаки",
    "posePassLabel": "Поза",
    "livenessPassLabel": "Liveness",
    "front": "Передняя часть",
    "left": "Левый",
    "right": "Верно",
    "approve": "Утвердить",
    "reject": "Отклонить",
    "eventCity": "Город событий",
    "eventCityHelp": "Изменяет город в вашей ленте и на карте."
  },
  "chat": {
    "title": "Чат",
    "subtitle": "Чаты, запросы vibe и отправленные vibes",
    "chats": "Чаты",
    "vibeRequests": "Vibe Запросы",
    "sentVibes": "Отправлено Vibes",
    "searchChats": "Поиск в чатах",
    "noMessages": "Сообщений пока нет",
    "noChatsFound": "Чатов не найдено",
    "noChatsYet": "Чатов пока нет",
    "tryDifferentKeyword": "Попробуйте другое имя или ключевое слово.",
    "chatsAppearHere": "Здесь будут отображаться ваши чаты",
    "joinToStart": "Присоединяйтесь к событию или отправьте vibe, чтобы начать общение.",
    "signInToUseVibes": "Войдите, чтобы использовать vibes",
    "signInSub": "Создайте учетную запись для просмотра запросов vibe и частных чатов.",
    "translateChat": "Перевести чат",
    "translatingChat": "Перевод...",
    "showOriginal": "Показать оригинал",
    "translationFailed": "Не удалось перевести чат.",
    "chatUnmuted": "Звук в чате включен",
    "chatMuted": "Звук в чате отключен",
    "leftChat": "Вы вышли из чата",
    "blockUserQuestion": "Заблокировать пользователя?",
    "blockUserMessage": "Вы больше не будете видеть сообщения от {name}. Блокировка является односторонней и не будет уведомлять их.",
    "thisUser": "этот пользователь",
    "block": "Блокировать",
    "userBlocked": "Пользователь заблокирован",
    "couldNotBlockUser": "Не удалось заблокировать пользователя.",
    "deleteChatQuestion": "Удалить чат?",
    "deleteChatMessage": "Этот чат будет удален без возможности восстановления. Это действие нельзя будет отменить.",
    "chatDeleted": "Чат удален",
    "couldNotDeleteChat": "Не удалось удалить чат.",
    "deletePlanMessage": "План и чат в нем будут удалены навсегда для всех участников.",
    "vibePromptsReady": "Ваши запросы на синхронизацию vibe готовы.",
    "you": "Ты",
    "traveler": "Участник Tonyte",
    "tonyteEvent": "TONYTE СОБЫТИЕ",
    "openEvent": "Открытое мероприятие",
    "directMessage": "Прямое сообщение",
    "youBlockedUser": "Вы заблокировали этого пользователя",
    "unblockInSettings": "Разблокируйте их в настройках профиля, чтобы снова увидеть этот чат.",
    "vibeEnded": "Этот Vibe завершён",
    "vibeEndedBody": "Эта связь и история чата больше не существуют. Отправьте новый запрос Vibe, чтобы снова связаться.",
    "eventChatEnded": "Это событие завершилось",
    "planChatEnded": "Этот план завершился",
    "removeFromPlan": "Удалить из плана",
    "removeFromPlanQuestion": "Удалить {name} из этого плана?",
    "removeFromPlanMessage": "Этот человек потеряет доступ к чату плана и больше не будет его участником.",
    "removedFromPlan": "Вас удалили из этого плана.",
    "memberRemoved": "Участник удалён",
    "couldNotRemoveMember": "Не удалось удалить этого участника. Попробуйте ещё раз.",
    "typeMessage": "Введите сообщение...",
    "couldNotSendImage": "Не удалось отправить изображение.",
    "locationUnavailable": "Местоположение недоступно.",
    "couldNotSendLocation": "Не удалось отправить местоположение.",
    "sharedLocationLabel": "Общий доступ к местоположению",
    "viewOnMap": "Посмотреть на карте",
    "invalidSharedLocation": "Это местоположение сейчас нельзя открыть.",
    "eventExpiredLabel": "ИСТЕКЛО",
    "eventExpired": "Мероприятие больше не активно",
    "eventExpiredToast": "Это мероприятие больше недоступно.",
    "microphoneNowEnabled": "Доступ к микрофону включён",
    "reply": "Ответить",
    "gifs": "GIF",
    "gifSearchResults": "Результаты поиска",
    "gifTrendingNow": "Сейчас в тренде",
    "searchGiphy": "Поиск в GIPHY",
    "recentlyUsed": "Недавние",
    "gifsLoadFailed": "Не удалось загрузить GIF. Проверьте подключение и повторите попытку.",
    "microphoneAccessNeeded": "Нужен доступ к микрофону",
    "microphoneAccessMessage": "Tonyte нужен доступ к микрофону для отправки голосовых сообщений. Включите его в настройках.",
    "recordingUnavailable": "Запись недоступна",
    "recordingUnavailableMessage": "Не удалось начать запись. Попробуйте ещё раз.",
    "wantsToVibe": "Хочет vibe с тобой",
    "status": "Статус: {status}",
    "accepted": "Принято",
    "passed": "Пройдено",
    "pending": "Ожидается",
    "profileSource": "Профиль Tonyte",
    "sharedPlan": "Общий план",
    "sharedEvent": "Общее событие",
    "noRequestMessage": "Сообщений пока не добавлено.",
    "vibe": "Vibe",
    "pass": "Пройдено",
    "alreadyVibing": "Уже вибрация",
    "cancel": "Отмена",
    "delete": "Удалить",
    "vibeVerified": "Vibe Проверено",
    "bio": "Биография",
    "interests": "Интересы",
    "requestMessage": "Сообщение запроса",
    "viewProfile": "Посмотреть профиль",
    "working": "Работаю...",
    "cancelRequest": "Отменить запрос",
    "peopleHere": "ЗДЕСЬ ЛЮДИ",
    "connectTravelers": "Найди своих людей",
    "loadingTravelers": "Загрузка участников...",
    "tryAgain": "Попробуйте еще раз",
    "noTravelers": "Здесь пока больше никого нет.",
    "noTravelersSub": "Будьте первым, кто откроет «Люди здесь», и ваша карточка будет видна другим.",
    "vibing": "Вибрация",
    "sent": "Отправлено",
    "accept": "Принять",
    "sendVibe": "Отправьте vibe",
    "sendVibeSub": "Добавьте короткую заметку для {name}. Вы также можете отправить его пустым.",
    "optionalMessage": "Дополнительное сообщение...",
    "sending": "Отправка...",
    "sendVibeAction": "Отправить Vibe",
    "planChat": "ПЛАН ЧАТ",
    "eventChat": "ЧАТ СОБЫТИЙ",
    "communityPlan": "План сообщества",
    "officialEvent": "Официальное мероприятие",
    "vibingWith": "Вибрация с",
    "groupCount": "{count} {people} в этом чате {kind}",
    "person": "человек",
    "people": "люди",
    "plan": "план",
    "event": "событие",
    "loadingMembers": "Загрузка участников...",
    "openProfiles": "Откройте профили и отправьте vibes",
    "deleteChat": "Удалить чат",
    "leaveChat": "Выйти из чата",
    "adminCannotLeave": "Администраторы плана не могут покинуть чат. Вместо этого удалить этот план?",
    "noStay": "Нет, останься",
    "yesDeletePlan": "Да, удалить план",
    "leavePlanConfirm": "Выйти из чата этого плана? Вы можете повторно присоединиться со страницы плана.",
    "leaveEventConfirm": "Выйти из чата этого мероприятия?",
    "leaving": "Ухожу…",
    "leave": "Уйти",
    "safety": "БЕЗОПАСНОСТЬ",
    "reportPerson": "Отчет {name}",
    "chooseReason": "Сначала выберите причину.",
    "reportFailed": "Отчет не выполнен. Пожалуйста, попробуйте еще раз.",
    "optionalDetails": "Дополнительные сведения…",
    "submitReport": "Отправить отчет",
    "reportUser": "Сообщить о пользователе",
    "blockUser": "Заблокировать пользователя",
    "viewProfileTitle": "Посмотреть профиль",
    "muteChat": "Отключение звука в чате",
    "unmuteChat": "Включить звук в чате",
    "loadingRequests": "Загрузка запросов...",
    "noPendingRequests": "Нет ожидающих запросов vibe",
    "pendingRequestsSub": "Полученные запросы будут отображаться здесь, прежде чем они перейдут в чаты.",
    "loadingSent": "Загрузка отправлена vibes...",
    "noSent": "vibes пока не отправлено",
    "noSentSub": "Vibes, отправленные вами от People Here, будут отслеживаться здесь.",
    "reasonSpam": "Спам",
    "reasonHarassment": "Преследование",
    "reasonFake": "Поддельный профиль",
    "reasonContent": "Неприемлемый контент",
    "reasonScam": "Мошенничество или небезопасное поведение",
    "reasonOther": "Другое",
    "tonyteVenue": "ЛОКАЦИЯ TONYTE",
    "newMessage": "Новое сообщение",
    "newMessageFallback": "Вы получили новое сообщение.",
    "someone": "Кто-то",
    "requestAcceptFailed": "Не удалось принять запрос. Пожалуйста, попробуйте еще раз.",
    "requestDeclineFailed": "Не удалось отклонить запрос. Пожалуйста, попробуйте еще раз.",
    "requestCancelFailed": "Не удалось отменить запрос. Пожалуйста, попробуйте еще раз.",
    "travelersLoadFailed": "Не удалось загрузить участников. Попробуйте ещё раз.",
    "signInSendVibes": "Войдите в систему, чтобы отправлять запросы vibe.",
    "vibeRequestSendFailed": "Не удалось отправить запрос vibe. Пожалуйста, попробуйте еще раз.",
    "nowVibingWith": "Теперь вы излучаете атмосферу {name}!",
    "leaveFailed": "Не удалось выйти из чата. Пожалуйста, попробуйте еще раз.",
    "requestPassed": "Запрос принят",
    "gifSendFailed": "Не удалось отправить GIF. Попробуйте еще раз.",
    "voiceUploadFailed": "Не удалось загрузить голосовую заметку. Нажмите «Повторить» в сообщении.",
    "reportSubmitted": "Отчет отправлен",
    "now": "сейчас",
    "minutesShort": "{count} мин",
    "hoursShort": "{count} ч",
    "daysShort": "{count} д",
    "vibingCount_one": "{count} человек на вайбе",
    "vibingCount_few": "{count} человека на вайбе",
    "vibingCount_many": "{count} человек на вайбе",
    "vibingCount_other": "{count} человека на вайбе",
    "memberJoined": "{name} теперь в чате",
    "memberLeft": "{name} больше не в чате",
    "lastSeenJustNow": "Был(а) в сети только что",
    "lastSeenMinutes_one": "Был(а) в сети {count} минуту назад",
    "lastSeenMinutes_few": "Был(а) в сети {count} минуты назад",
    "lastSeenMinutes_many": "Был(а) в сети {count} минут назад",
    "lastSeenMinutes_other": "Был(а) в сети {count} минуты назад",
    "lastSeenHours_one": "Был(а) в сети {count} час назад",
    "lastSeenHours_few": "Был(а) в сети {count} часа назад",
    "lastSeenHours_many": "Был(а) в сети {count} часов назад",
    "lastSeenHours_other": "Был(а) в сети {count} часа назад",
    "lastSeenYesterday": "Последний раз видели вчера",
    "lastSeenDays_one": "Был(а) в сети {count} день назад",
    "lastSeenDays_few": "Был(а) в сети {count} дня назад",
    "lastSeenDays_many": "Был(а) в сети {count} дней назад",
    "lastSeenDays_other": "Был(а) в сети {count} дня назад",
    "lastSeenAWhileAgo": "Последний раз видели недавно",
    "seen": "Прочитано",
    "seenJustNow": "Прочитано только что",
    "seenMinutes_one": "Прочитано {count} минуту назад",
    "seenMinutes_few": "Прочитано {count} минуты назад",
    "seenMinutes_many": "Прочитано {count} минут назад",
    "seenMinutes_other": "Прочитано {count} минуты назад",
    "seenHours_one": "Прочитано {count} час назад",
    "seenHours_few": "Прочитано {count} часа назад",
    "seenHours_many": "Прочитано {count} часов назад",
    "seenHours_other": "Прочитано {count} часа назад",
    "yesterday": "Вчера",
    "typing": "Печатает...",
    "online": "Онлайн",
    "studiZonePlan": "План StudiZone"
  },
  "discover": {
    "heroTitle": "Vibes",
    "vibesSubtitle": "Люди. Места. Кампус.",
    "findMyVibeTitle": "Найти мой вайб",
    "findMyVibeDesc": "Пройди квиз. Найди своих.",
    "venuesCardDesc": "Профили партнёров.",
    "studiZoneCardDesc": "Сообщество кампуса.",
    "statusOpensAt": "Откроется в {time}",
    "statusResultsAt": "Результаты в {time}",
    "statusResultsOut": "Результаты готовы",
    "studiZoneVerifiedOnly": "Только для студентов",
    "infoPill": "Ответьте на несколько вопросов. Получите свой vibe. Найдите своих людей.",
    "addPhotoLocked": "Прежде чем использовать Social Discovery, добавьте настоящую фотографию профиля.",
    "daySubtitle": "Пройдите сегодняшний вайб-чек",
    "dayDescription": "Ответьте на несколько ежедневных вопросов, узнайте свою ауру, откройте Vibe Circle и найдите людей на своей волне.",
    "venueSubtitle": "Узнайте, кто создаёт атмосферу вашего города",
    "venueDescription": "Открывайте местные площадки, артистов, сообщества и организаторов. Подписывайтесь на любимых и находите их события, новости и календари.",
    "studiZoneTitle": "StudiZone",
    "studiZoneSubtitle": "Пространство для подтверждённых студентов",
    "studiZoneDescription": "Находите события кампуса, студенческие планы, сообщества и чаты для подтверждённых студентов.",
    "studiZoneButton": "Открыть StudiZone ->",
    "letsGo": "Поехали ->",
    "citySync": "Синхронизация города",
    "tonightSync": "Сегодняшняя синхронизация",
    "auraLockedText": "Впервые здесь? Не волнуйтесь.\nСегодняшнее сканирование aura начнется в 6:00 AM.",
    "auraQuestionsText": "Ответьте на вопросы.\nНайдите свой aura и разблокируйте свой Vibe Circle.",
    "auraResultsText": "Результаты.\nНайдите своего aura и того, с кем вы vibe сегодня.",
    "auraOpenTime": "6:00",
    "auraResultsTime": "1:00",
    "am": "AM",
    "pm": "PM",
    "live": "LIVE",
    "now": "СЕЙЧАС",
    "underConstruction": "В стадии разработки",
    "venueTesterUnavailable": "Vibe на площадках готовится к раннему доступу. Aura Vibe остается доступным."
  },
  "feedFilters": {
    "now": "Сейчас",
    "tonight": "Сегодня вечером",
    "parties": "Вечеринки",
    "social": "Социальные сети",
    "nearby": "Рядом",
    "high-energy": "Высокая энергия",
    "food": "Еда",
    "activities": "Действия",
    "chill": "Холод",
    "date-idea": "Идея свидания",
    "solo-friendly": "Дружелюбие в одиночку",
    "student": "Студент",
    "free": "Бесплатно"
  },
  "interests": {
    "addInterests": "Добавить интересы",
    "selectedInterests": "Избранные интересы",
    "selected": "выбрано",
    "searchInterests": "Поисковые интересы",
    "add": "Добавить",
    "saveInterests": "Сохранить интересы",
    "categories": {
      "travel": "Путешествие",
      "food_and_drinks": "Еда и напитки",
      "nightlife": "Ночная жизнь",
      "sports_and_fitness": "Спорт и фитнес",
      "music": "Музыка",
      "art_and_creativity": "Искусство и творчество",
      "social_and_culture": "Социальная жизнь и культура",
      "tech_and_gaming": "Технологии и игры",
      "outdoors": "На открытом воздухе",
      "relax_and_lifestyle": "Отдых и образ жизни"
    },
    "items": {
      "backpacking": "Рюкзак",
      "road_trips": "Путешествия",
      "solo_travel": "Одиночное путешествие",
      "luxury_travel": "Роскошное путешествие",
      "digital_nomad": "Цифровой кочевник",
      "adventure_travel": "Приключенческое путешествие",
      "city_exploration": "Исследование города",
      "beach_trips": "Поездки на пляж",
      "mountains": "Горы",
      "camping": "Кемпинг",
      "street_food": "Уличная еда",
      "fine_dining": "Изысканная кухня",
      "cafes": "Кафе",
      "bars": "Бары",
      "cocktails": "Коктейли",
      "wine_tasting": "Дегустация вин",
      "beer": "Пиво",
      "cooking": "Кулинария",
      "vegan_food": "Веганская еда",
      "desserts": "Десерты",
      "clubbing": "Клубы",
      "house_music": "Хаус-музыка",
      "techno": "Техно",
      "hip_hop": "Хип-хоп",
      "live_djs": "Диджеи Live",
      "pub_crawls": "Сканирование пабов",
      "after_parties": "После вечеринки",
      "festivals": "Фестивали",
      "dance": "Танец",
      "karaoke": "Караоке",
      "gym": "Тренажерный зал",
      "running": "Бег",
      "football": "Футбол",
      "basketball": "Баскетбол",
      "yoga": "Йога",
      "hiking": "Походы",
      "cycling": "Езда на велосипеде",
      "swimming": "Плавание",
      "martial_arts": "Боевые искусства",
      "crossfit": "CrossFit",
      "rap": "Рэп",
      "pop": "Поп",
      "rock": "Рок",
      "edm": "EDM",
      "jazz": "Джаз",
      "classical": "Классика",
      "indie": "Инди",
      "lo_fi": "Низкокачественное качество",
      "live_concerts": "Live Концерты",
      "singing": "Пение",
      "photography": "Фотография",
      "painting": "Живопись",
      "graphic_design": "Графический дизайн",
      "illustration": "Иллюстрация",
      "3d_art": "3D-арт",
      "videography": "Видеосъемка",
      "content_creation": "Создание контента",
      "fashion": "Мода",
      "tattoo_art": "Искусство татуировки",
      "animation": "Анимация",
      "meeting_people": "Знакомство с людьми",
      "languages": "Языки",
      "cultural_exchange": "Культурный обмен",
      "volunteering": "Волонтерство",
      "networking": "Сеть",
      "events": "События",
      "public_speaking": "Публичное выступление",
      "debates": "Дебаты",
      "history": "История",
      "museums": "Музеи",
      "gaming": "Игры",
      "pc_gaming": "Компьютерные игры",
      "console_gaming": "Консольные игры",
      "ai": "ИИ",
      "startups": "Стартапы",
      "coding": "Кодирование",
      "cybersecurity": "Кибербезопасность",
      "web3": "Web3",
      "gadgets": "Гаджеты",
      "esports": "Киберспорт",
      "nature": "Природа",
      "sunsets": "Закаты",
      "photography_walks": "Фотопрогулки",
      "picnics": "Пикники",
      "fishing": "Рыбалка",
      "climbing": "Восхождение",
      "kayaking": "Каякинг",
      "skiing": "Катание на лыжах",
      "snowboarding": "Сноубординг",
      "wildlife": "Дикая природа",
      "netflix": "Netflix",
      "reading": "Чтение",
      "meditation": "Медитация",
      "spa": "Спа",
      "journaling": "Ведение журнала",
      "podcasts": "Подкасты",
      "shopping": "Покупки",
      "minimalism": "Минимализм",
      "self_growth": "Саморазвитие",
      "coffee": "Кофе"
    }
  },
  "feed": {
    "free": "Бесплатно",
    "freeEntry": "Вход бесплатный",
    "paidEntry": "Платный вход",
    "ongoing": "Продолжается",
    "nowOn": "Сейчас начнётся",
    "runsUntil": "Работает до тех пор, пока",
    "until": "до тех пор, пока",
    "peopleGoing": "человек идут",
    "peopleGoingCount_one": "Идёт {count} человек",
    "peopleGoingCount_few": "Идут {count} человека",
    "peopleGoingCount_many": "Идут {count} человек",
    "peopleGoingCount_other": "Идут {count} человека",
    "tonyteVenue": "Место проведения Tonyte",
    "ticketsFrom": "Билеты из",
    "eyebrow": "Официальные мероприятия и мероприятия поблизости",
    "whatsOnIn": "Что происходит в",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "date": "Дата",
    "gettingLocation": "Получение вашего местоположения...",
    "locationDenied": "Доступ к местоположению запрещен. Включите его в настройках, чтобы видеть ближайшие события.",
    "enableLocation": "Включите местоположение, чтобы видеть события поблизости.",
    "featuredThisWeek": "Избранное на этой неделе",
    "topPicksForYou": "Подборка для вас",
    "popularNearYou": "Популярно рядом с вами",
    "topPicksError": "Не удалось загрузить вашу подборку.",
    "topPicksSubtitle": "События, подобранные по вашим интересам",
    "topPicksSubtitlePopular": "Популярные события рядом с вами",
    "topPicksSeeAll": "Смотреть все",
    "topPicksBadge": "Для вас",
    "topPicksEyebrow": "Рекомендовано для вас",
    "topPicksReason": {
      "interest": "Потому что вам нравится {interest}",
      "category": "Соответствует вашим интересам в категории «{category}»",
      "joined": "Похоже на события, к которым вы присоединились",
      "shared": "Похоже на события, которыми вы поделились",
      "viewed": "На основе событий, которые вы просматривали"
    },
    "allEvents": "Все события",
    "searchPlaceholder": "Найди свой следующий вайб…",
    "searchAccessibility": "Поиск событий, клубов или тегов",
    "searchResults": "Результаты поиска",
    "searchEmpty": "Нет событий по запросу «{query}»",
    "searchEmptySub": "Попробуй другое название, клуб или тег.",
    "loadingEvents": "Загрузка событий...",
    "noEventsFound": "События не найдены",
    "noEventsSub": "Повторите попытку позже или попробуйте другой фильтр."
  },
  "featuredAdmin": {
    "title": "Добавить в избранное",
    "thisWeek": "Эта неделя",
    "nextWeek": "Следующая неделя",
    "custom": "Свой период",
    "startDate": "Дата начала",
    "endDate": "Дата окончания",
    "priority": "Приоритет показа",
    "priorityHint": "1 показывается первым. Меньшие числа идут раньше.",
    "currentlyFeatured": "Это событие сейчас в «Избранном на этой неделе».",
    "save": "Сохранить",
    "saveAnyway": "Всё равно добавить",
    "remove": "Убрать",
    "checkingPartner": "Проверка аккаунта партнёра…",
    "verifiedPartner": "Опубликовано проверенным партнёром Tonyte.",
    "notPartner": "Это событие опубликовано не проверенным партнёрским аккаунтом. Избранное предназначено для событий партнёров.",
    "unknownPartner": "Не удалось проверить аккаунт партнёра. Избранное предназначено для событий партнёров.",
    "errors": {
      "invalidDate": "Введите даты в формате ГГГГ-ММ-ДД.",
      "endBeforeStart": "Дата окончания должна быть позже даты начала.",
      "alreadyEnded": "Этот период показа уже закончился.",
      "invalidPriority": "Приоритет — целое число от 1 до 999.",
      "saveFailed": "Не удалось сохранить. Попробуйте ещё раз."
    }
  },
  "map": {
    "loadingMap": "Загрузка карты...",
    "showEvents": "Показать события",
    "hide": "Скрыть",
    "noMappedEvents": "Поблизости нет сопоставленных событий.",
    "noMappedEventsNearby": "Поблизости нет сопоставленных событий",
    "selectDate": "Выберите дату",
    "selectCity": "Выберите город",
    "myLocation": "Мое местоположение",
    "locating": "Поиск…",
    "locationDeniedTitle": "Местоположение отклонено",
    "locationDeniedMsg": "Чтобы использовать эту функцию, включите доступ к местоположению в настройках.",
    "locationUnavailableTitle": "Местоположение недоступно",
    "locationUnavailableMsg": "Не удалось определить ваше местоположение. Пожалуйста, попробуйте еще раз.",
    "locationUnavailable": "Местоположение недоступно",
    "locationPermissionDenied": "Разрешение на определение местоположения отклонено",
    "locationUnavailableHint": "Включите службы определения местоположения и повторите попытку.",
    "locationPermissionDeniedHint": "Разрешите доступ к местоположению в настройках, чтобы использовать свое местоположение.",
    "recenterToMyLocation": "Перецентрировать к моему местоположению",
    "invalidSharedLocation": "Это местоположение сейчас нельзя показать.",
    "dismissSharedLocation": "Скрыть общий доступ к местоположению"
  },
  "categories": {
    "social": "Социальные сети",
    "adventure": "Приключение",
    "culture": "Культура",
    "food": "Еда",
    "nightlife": "Ночная жизнь"
  },
  "event": {
    "chatNoLongerAvailable": "Чат больше недоступен",
    "chatNoLongerAvailableBody": "Этот чат больше не существует, потому что мероприятие завершилось.",
    "plan": "План",
    "communityPlan": "План сообщества",
    "officialEvent": "Официальное мероприятие",
    "clubEvent": "Клубное мероприятие",
    "jamSession": "Джем-сессия",
    "tonight": "Сегодня вечером",
    "interested": "заинтересованы",
    "interestedCount_one": "Заинтересован {count} человек",
    "interestedCount_few": "Заинтересованы {count} человека",
    "interestedCount_many": "Заинтересованы {count} человек",
    "interestedCount_other": "Заинтересованы {count} человека",
    "interestedBtn": "Заинтересовано",
    "members": "участники",
    "memberCount_one": "{count} участник",
    "memberCount_few": "{count} участника",
    "memberCount_many": "{count} участников",
    "memberCount_other": "{count} участника",
    "eventChat": "Чат мероприятия",
    "joiningChat": "Присоединение…",
    "openVenue": "Открытая площадка",
    "organizer": "Организатор",
    "leavePlan": "План отпуска",
    "requestSentShort": "Запрос отправлен",
    "openChat": "Открыть чат",
    "planChat": "План чата",
    "dateTba": "Дата будет объявлена позднее",
    "timeTba": "Время будет объявлено позднее",
    "decline": "Отказ",
    "accept": "Принять",
    "tonyteNight": "Вечер Tonyte, на который стоит прийти.",
    "lowRisk": "Низкий риск",
    "lowRiskSub": "Публичный или четко описанный план",
    "caution": "Внимание!",
    "cautionSub": "Рекомендуется особый уход.",
    "highRisk": "Высокий риск",
    "highRiskSub": "Частные или конфиденциальные сведения о плане",
    "aboutThisPlan": "Об этом плане",
    "aboutThisEvent": "Об этом событии",
    "detailsFinalized": "Детали уточняются.",
    "lineup": "Состав",
    "genres": "Жанры",
    "signInToJoinChats": "Войдите, чтобы присоединиться к чатам событий.",
    "signInToMarkInterested": "Войдите в систему, чтобы отмечать события как интересные.",
    "signInToJoinPlans": "Войдите в систему, чтобы присоединиться к планам.",
    "chatUnavailable": "Чат недоступен",
    "noEventChat": "Это мероприятие не включает в себя чат.",
    "couldNotJoinChat": "Не удалось присоединиться к чату.",
    "removedFromPlan": "Вас удалили из этого плана.",
    "requestSent": "Запрос отправлен!",
    "organizerWillReview": "Организатор рассмотрит ваш запрос.",
    "couldNotSendRequest": "Не удалось отправить запрос.",
    "leftPlan": "План слева",
    "couldNotLeavePlan": "Не удалось покинуть план.",
    "planDeleted": "План удален",
    "couldNotDeletePlan": "Не удалось удалить план.",
    "couldNotDeleteEvent": "Не удалось удалить событие.",
    "noDateAvailable": "Дата не доступна.",
    "noScheduledTime": "Для этого мероприятия еще нет запланированного времени.",
    "openingGoogleCalendar": "Открытие календаря Google...",
    "confirmCalendarSave": "Подтвердите, чтобы сохранить событие.",
    "deleteEventQuestion": "Удалить мероприятие?",
    "deleteEventConfirm": "Вы уверены, что хотите удалить это мероприятие? Это действие невозможно отменить.",
    "joinEventChatQuestion": "Присоединиться к чату мероприятия?",
    "joinEventChatPrompt": "Хотите отметить заинтересованного и присоединиться к чату мероприятия?",
    "interestedOnly": "Только для интереса",
    "joinChat": "Присоединиться к чату",
    "shareEvent": "Поделиться событием",
    "shareOutsideTonyte": "Общий доступ за пределами Tonyte",
    "sendInTonyteChat": "Отправить в чат Tonyte",
    "foundOnTonyte": "Нашёл это на Tonyte.",
    "openGoogleMaps": "Открыть в картах Google",
    "openMaps": "Открыть в Картах",
    "couldNotOpenMaps": "Не удалось открыть карты.",
    "couldNotOpenEventLink": "Не удалось открыть ссылку на мероприятие.",
    "viewOfficialEvent": "Посмотреть официальное мероприятие",
    "capacity": "Емкость",
    "dateTime": "Дата и время",
    "calendar": "Календарь",
    "addToCalendar": "Добавить в календарь",
    "publishedBy": "Опубликовано",
    "openGoogleCalendar": "Открыть календарь Google",
    "couldNotOpenCalendar": "Не удалось открыть календарь.",
    "location": "Местоположение",
    "exactLocationAfterApproval": "Точное местоположение сообщается в чате плана после утверждения.",
    "joinRequests": "Запросы на присоединение",
    "couldNotAccept": "Не удалось принять",
    "couldNotDecline": "Не удалось отклонить",
    "requestToJoin": "Запрос на присоединение?",
    "highRiskWarning": "Этот план может быть конфиденциальным или конфиденциальным. Пожалуйста, соблюдайте особую осторожность.",
    "mediumRiskWarning": "Этот план может включать алкоголь или ночную жизнь. Будьте внимательны к своему окружению.",
    "ackRisks": "Я понимаю риски и хочу продолжить",
    "messageOrganizerOptional": "Добавить сообщение организатору (необязательно)",
    "sendRequest": "Отправить запрос",
    "deleteEventConfirmShort": "Ты уверен? Это действие невозможно отменить.",
    "requestToJoinFirst": "Сначала запросите присоединение",
    "requestToJoinFirstMsg": "Отправьте запрос на присоединение, чтобы получить доступ к чату плана, как только он будет принят.",
    "cancelRequestQuestion": "Отменить запрос?",
    "cancelRequestMsg": "Отозвать свой запрос на присоединение к этому плану?",
    "keepRequest": "Сохранить запрос",
    "cancelRequest": "Отменить запрос",
    "couldNotCancel": "Не удалось отменить",
    "adminCannotLeave": "Администраторы планов не могут покидать планы.",
    "deletePlanInstead": "Вместо этого удалить этот план?",
    "deletePlanQuestion": "Удалить план?",
    "noStay": "Нет, останься",
    "yesDeletePlan": "Да, удалить план",
    "venuePost": "Сообщение о месте проведения",
    "hostedBy": "Хостинг:",
    "addComment": "Добавить комментарий...",
    "comments": "Комментарии",
    "tonyteUser": "Пользователь Tonyte",
    "shareIntro": "Присоедитесь к этому событию в Tonyte 🎉",
    "couldNotShare": "Не удалось поделиться",
    "missingShareableId": "У этого события нет ID для публикации.",
    "nativeShareUnavailable": "Системное меню «Поделиться» сейчас недоступно.",
    "missingExternalLink": "Это событие еще не содержит ссылки.",
    "couldNotUpdateInterest": "Не удалось обновить статус «Интересно».",
    "eventsCount_one": "{count} событие",
    "eventsCount_few": "{count} события",
    "eventsCount_many": "{count} событий",
    "eventsCount_other": "{count} события",
    "joinedCount_one": "{count} участник",
    "joinedCount_few": "{count} участника",
    "joinedCount_many": "{count} участников",
    "joinedCount_other": "{count} участника"
  },
  "plans": {
    "myPlans": "Мои планы",
    "communityPlans": "Планы сообщества",
    "communityPlansSubtitle": "Присоединяйтесь к групповым приключениям рядом с вами",
    "communityPlanBadge": "ПЛАН СООБЩЕСТВА",
    "freeBadge": "БЕСПЛАТНО",
    "postedBy": "Автор:",
    "member": "участник",
    "open": "Открыть",
    "leave": "Уйти",
    "request": "Запрос",
    "loading": "Загрузка планов...",
    "noneYet": "Планов сообщества пока нет",
    "noneYetSubtitle": "Составьте план знакомства с новыми людьми и совместных исследований.",
    "createPlan": "Создать план",
    "completeProfile": "Заполните свой профиль, чтобы просмотреть планы",
    "addRealProfilePicture": "Добавьте настоящее фото профиля",
    "completeProfileSubtitle": "Настоящее фото профиля необходимо, прежде чем вы сможете присоединяться к планам сообщества или создавать их.",
    "signInTitle": "Войдите, чтобы просмотреть планы",
    "signInSubtitle": "Создайте учетную запись, чтобы присоединяться к групповым приключениям и организовывать их.",
    "signInRequiredSubtitle": "Чтобы присоединиться к планам, вам необходимо войти в систему.",
    "leaveFailed": "Не удалось выйти из плана. Пожалуйста, попробуйте еще раз.",
    "planDeleted": "План удален",
    "removed": "был удален.",
    "deleteFailed": "Не удалось удалить план. Пожалуйста, попробуйте еще раз.",
    "requestSent": "Запрос отправлен!",
    "requestSentSubtitle": "Организатор плана рассмотрит ваш запрос.",
    "requestFailed": "Не удалось отправить ваш запрос. Пожалуйста, попробуйте еще раз.",
    "deletePlan": "Удалить план",
    "deletePlanConfirmPrefix": "Удалить",
    "deletePlanConfirmSuffix": "навсегда? Это невозможно отменить.",
    "templatesTitle": "Нужна идея?",
    "templatesSubtitle": "Выберите план и сделайте его своим."
  },
  "share": {
    "sentToChats": "Отправлено в {count} чат",
    "sentToChatsCount_one": "Отправлено в {count} чат",
    "sentToChatsCount_few": "Отправлено в {count} чата",
    "sentToChatsCount_many": "Отправлено в {count} чатов",
    "sentToChatsCount_other": "Отправлено в {count} чата",
    "couldNotSend": "Не удалось отправить. Пожалуйста, попробуйте еще раз."
  },
  "forms": {
    "searchAddressOrVenue": "Найти адрес или место проведения..."
  },
  "completeProfile": {
    "couldNotSave": "Не удалось сохранить. Попробуйте еще раз.",
    "couldNotUploadCover": "Не удалось загрузить обложку.",
    "couldNotUploadProfilePhoto": "Не удалось загрузить фотографию профиля.",
    "doneTitle": "Улучшен профиль!",
    "complete": "Завершено",
    "doneSub": "Ваш профиль теперь стал более доступен для обнаружения. Лучшие рекомендации, более умные матчи и более актуальные события ждут вас.",
    "backToProfile": "Вернуться к профилю",
    "profileBoost": "ПОВЫШЕНИЕ ПРОФИЛЯ",
    "enhanceExperience": "Улучшите свои впечатления",
    "addProfilePicture": "Добавить изображение профиля",
    "addProfilePictureSub": "Реальная фотография поможет людям узнавать вас в vibes, чатах и планах.",
    "uploadPhoto": "Загрузить фото",
    "keepCurrent": "Будьте в курсе",
    "skipStep": "Пропустите этот шаг.",
    "dobTitle": "Ваша дата рождения",
    "dobSub": "Это значение можно установить только один раз, при этом Tonyte будет соответствовать возрасту.",
    "dobPlaceholder": "Выберите день, месяц, год",
    "chooseDob": "Чтобы продолжить, выберите дату своего рождения.",
    "underMinAge": "Tonyte предназначен для путешественников в возрасте от 16 лет и старше.",
    "saveContinue": "Сохранить и продолжить",
    "interestsTitle": "Чем ты увлекаешься?",
    "interestsSub": "Выберите хотя бы 3, чтобы Tonyte мог настроить ваши рекомендации.",
    "selected": "выбрано",
    "pickInterests": "Выберите не менее 3 интересов.",
    "locationTitle": "Где вы находитесь?",
    "locationSub": "Ваш базовый город помогает Tonyte поддерживать актуальность людей и планов.",
    "city": "Город",
    "country": "Страна",
    "addBaseCity": "Чтобы продолжить, добавьте свой базовый город.",
    "bioTitle": "Расскажи свою историю",
    "bioSub": "Короткое описание помогает другим понять, с кем они встречаются.",
    "bioPlaceholder": "Напишите что-нибудь о себе — чем увлекаетесь, что любите, куда любите ходить...",
    "coverTitle": "Добавьте обложку",
    "coverSub": "Красивая обложка выделит ваш профиль в Discover.",
    "tapChooseCover": "Нажмите, чтобы выбрать обложку.",
    "uploadCover": "Загрузить обложку",
    "vibeTitle": "Какой у тебя vibe?",
    "vibeSub": "Ваша индивидуальность в путешествии помогает нам рекомендовать подходящие события и людей.",
    "musicTitle": "Ваш музыкальный вкус",
    "musicSub": "Мы найдем события, соответствующие вашей любимой музыке. Берите до 5.",
    "languagesTitle": "Языки, на которых вы говорите",
    "languagesSub": "Найдите путешественников, с которыми вы действительно можете поговорить. Выберите все, что подходит.",
    "goingOutTitle": "Стиль выхода в свет",
    "goingOutSub": "Какие ночи тебе нравятся? Выберите все, что применимо.",
    "saveFinish": "Сохранить и завершить",
    "saveExit": "Сохранить и выйти",
    "socialVibeButterfly": "Социальная бабочка",
    "socialVibeButterflyDesc": "Вам нравится знакомиться с новыми людьми.",
    "socialVibeAdventurer": "Искатель приключений",
    "socialVibeAdventurerDesc": "Вы ищете острых ощущений и новых мест.",
    "socialVibeFoodie": "Гурман",
    "socialVibeFoodieDesc": "Еда – это ваш язык любви.",
    "socialVibeNightlife": "Любитель ночной жизни",
    "socialVibeNightlifeDesc": "Лучшее время — после полуночи.",
    "socialVibeCulture": "Охотник за культурой",
    "socialVibeCultureDesc": "Музеи, искусство, история — все это.",
    "socialVibeChill": "Расслабление и расслабление",
    "socialVibeChillDesc": "Медленное путешествие, хорошо vibes.",
    "music_techno": "Техно",
    "music_house": "Дом",
    "music_hipHop": "Хип-хоп",
    "music_rAndB": "Р&Б",
    "music_pop": "Поп",
    "music_rock": "Рок",
    "music_indie": "Инди",
    "music_edm": "ЭДМ",
    "music_jazz": "Джаз",
    "music_classical": "Классика",
    "music_reggaeton": "Реггетон",
    "music_afrobeats": "Афробиты",
    "music_loFi": "Низкое качество изображения",
    "music_drumBass": "Драм-н-бэйс",
    "music_ambient": "Окружающая среда",
    "spoken_english": "английский",
    "spoken_german": "Немецкий",
    "spoken_french": "Французский",
    "spoken_spanish": "Испанский",
    "spoken_italian": "Итальянский",
    "spoken_portuguese": "Португальский",
    "spoken_dutch": "Голландский",
    "spoken_polish": "Польский",
    "spoken_czech": "Чешский",
    "spoken_romanian": "Румынский",
    "spoken_greek": "Греческий",
    "spoken_hungarian": "Венгерский",
    "spoken_swedish": "Шведский",
    "spoken_danish": "Датский",
    "spoken_finnish": "Финский",
    "spoken_hindi": "Хинди",
    "spoken_ukrainian": "Украинский",
    "spoken_russian": "Русский",
    "spoken_arabic": "Арабский",
    "spoken_chinese": "Китайский",
    "spoken_japanese": "Японский",
    "goingOutClubs": "Клубы и вечеринки",
    "goingOutBars": "Бары и пабы",
    "goingOutRooftops": "Крыши и террасы",
    "goingOutLiveMusic": "Живая музыка",
    "goingOutChill": "Холодные места",
    "goingOutStreetFood": "Уличная еда и рынки"
  },
  "profile": {
    "myVenueProfile": "Мой профиль партнёра",
    "myVenueProfileSub": "Посмотрите на заведение глазами гостей",
    "basedIn": "Базируется в",
    "locationNotAdded": "Местоположение не добавлено",
    "addBio": "Добавьте что-нибудь о себе",
    "recently": "Недавно",
    "events": "События",
    "plans": "Планы",
    "interests": "Интересы",
    "attended": "Присутствовал",
    "created": "Создано",
    "saved": "Сохранено.",
    "memberSince": "Участник с",
    "exploringSince": "С тех пор вместе с Tonyte.",
    "tapToChangeCity": "Изменить ленту и город на карте",
    "viewAll": "Посмотреть все",
    "addInterest": "Добавить интерес",
    "uploadEvent": "Событие загрузки",
    "signOut": "Выход",
    "signOutConfirm": "Вы уверены, что хотите выйти?",
    "cancel": "Отмена",
    "createAccountOrSignIn": "Создайте учетную запись или войдите в систему",
    "logOut": "Выход из системы",
    "personality": "Личность",
    "editProfile": "Редактировать профиль",
    "shareProfile": "Поделиться профилем",
    "qrCode": "QR-код",
    "verifications": "Проверки",
    "vibeVerified": "Vibe Проверено",
    "studentVerified": "Студент проверен",
    "earlyMember": "Ранний участник",
    "topPlanner": "Лучший планировщик",
    "eventHost": "Хозяин мероприятия",
    "aura": "Aura",
    "myPlans": "Мои планы",
    "loadingPlans": "Загрузка планов...",
    "upcomingPlansEmpty": "Здесь появятся ваши планы на будущее.",
    "createPlan": "Создать план",
    "upcomingEvents": "Предстоящие события",
    "loadingEvents": "Загрузка событий...",
    "upcomingEventsEmpty": "Предстоящих событий пока нет.",
    "interestedEvents": "Интересные события",
    "loadingInterestedEvents": "Загрузка интересующих событий...",
    "interestedEventsEmpty": "Здесь появятся события, которые вы отметите как интересующие.",
    "browseEvents": "Просмотр событий",
    "badgesAchievements": "Значки и достижения",
    "savedTemplates": "Сохраненные шаблоны",
    "reusableEventDrafts": "Повторно используемые черновики событий",
    "uploadedPlans": "Загруженные планы",
    "yourCreatedPlans": "Созданные вами планы",
    "planRequests": "Запросы плана",
    "pendingPlanRequests": "Ожидающие запросы на присоединение к вашим планам",
    "todaysVibe": "Сегодняшний Vibe",
    "todaysVibePrompt": "Узнайте свой вайб",
    "todaysVibePromptSub": "Ответьте на пару вопросов",
    "loadingVibeMatches": "Загрузка совпадений vibe...",
    "vibeMatchWaiting": "Ожидание совпадения vibe",
    "vibeMatchesWaiting": "vibe-совпадения ждут",
    "vibeMatchWaitingCount_one": "Ждёт {count} vibe-совпадение",
    "vibeMatchWaitingCount_few": "Ждут {count} vibe-совпадения",
    "vibeMatchWaitingCount_many": "Ждут {count} vibe-совпадений",
    "vibeMatchWaitingCount_other": "Ждут {count} vibe-совпадения",
    "following": "Подписки",
    "followingSearch": "Поиск по подпискам",
    "followingEmpty": "Вы пока ни на кого не подписаны. Найдите партнёров в Vibe at Venues.",
    "followingNoMatch": "Партнёры не найдены.",
    "followingCount_one": "{count} партнёр",
    "followingCount_few": "{count} партнёра",
    "followingCount_many": "{count} партнёров",
    "followingCount_other": "{count} партнёра",
    "studiZoneOpen": "Открыть",
    "studiZonePending": "На проверке",
    "studiZoneVerify": "Подтвердить",
    "updateRole": "Обновить роль пользователя?",
    "changeRole": "Изменить роль {name} с {from} на {to}?",
    "updateRoleAction": "Обновить роль",
    "noRolePermission": "У вас нет разрешения на обновление этой роли.",
    "coAdminRoleRestriction": "Соадмины не могут назначать или изменять учетные записи администратора/соадминистратора.",
    "adminSignInRequired": "Для обновления ролей необходимо войти в систему как администратор.",
    "roleUpdateFailed": "Сейчас невозможно обновить роль.",
    "roleUpdated": "Роль пользователя обновлена.",
    "uploadingProfile": "Загрузка фотографии профиля…",
    "uploadingCover": "Загрузка обложки…",
    "profileSaved": "Фотография профиля сохранена.",
    "coverSaved": "Обложка сохранена.",
    "imageUpdateFailed": "Не удалось обновить изображение.",
    "removeProfilePhoto": "Удалить фотографию профиля?",
    "removeCoverPhoto": "Удалить обложку?",
    "restoreDefault": "Это восстановит изображение по умолчанию.",
    "remove": "Удалить",
    "imageRemoveFailed": "Не удалось удалить изображение.",
    "interestsSaveFailed": "Не удалось сохранить интересы.",
    "notificationsSaveFailed": "Не удалось сохранить уведомления.",
    "reviewFailed": "Не удалось просмотреть запрос.",
    "unchanged": "Повторите попытку — ничего не изменилось.",
    "revokeFailed": "Не удалось отозвать значок.", "revokeSuccessTitle": "Vibe Verified отозван", "revokeSuccessBody": "Значок Vibe Verified этого пользователя удалён.",
    "shareFailed": "Не удалось поделиться",
    "missingShareId": "В этом профиле отсутствует общий идентификатор.",
    "shareUnavailable": "Собственный общий лист сейчас недоступен.",
    "qrUnavailable": "QR-код недоступен",
    "vibesHub": "Vibes",
    "vibesHubSub": "Ваш личный чат и контакты vibe",
    "admin": "Администратор",
    "userManagement": "Управление пользователями",
    "usersCount": "Пользователи {count}",
    "adminHelp": "Управляйте ролями Tonyte для пользователей, тестировщиков, организаторов, площадок, соадминистраторов и администраторов.",
    "userManagementSub": "Найдите пользователей и назначьте роли.",
    "studentVerifications": "Проверка учащихся",
    "faceVerificationRequests": "Запросы на проверку лица",
    "pendingReviewCount": "{count} ожидает рассмотрения",
    "loading": "Загрузка…",
    "change": "Изменить",
    "close": "Закрыть",
    "myQrCode": "Мой QR-код",
    "share": "Поделиться",
    "coverPhoto": "Фото на обложке",
    "viewCover": "Посмотреть обложку",
    "changeCover": "Сменить обложку",
    "removeCover": "Снимите крышку",
    "pendingReviewCount_one": "{count} ожидает рассмотрения",
    "pendingReviewCount_few": "{count} ожидают рассмотрения",
    "pendingReviewCount_many": "{count} ожидают рассмотрения",
    "pendingReviewCount_other": "{count} ожидают рассмотрения",
    "tonyteTraveler": "Tonyte Путешественник",
    "blockedAccountsLoadFailed": "Не удалось загрузить заблокированные аккаунты прямо сейчас.",
    "unblockFailed": "Не удалось разблокировать этот аккаунт прямо сейчас.",
    "noConnectedEmail": "К этой учетной записи не подключена электронная почта.",
    "passwordResetSent": "Ссылка для сброса пароля отправлена ​​на {email}.",
    "passwordResetFailed": "Не удалось отправить электронное письмо для сброса прямо сейчас.",
    "enterValidStudentEmail": "Введите действительный адрес электронной почты учащегося.",
    "studentVerificationEmailSent": "Письмо с подтверждением отправлено! Проверьте свой почтовый ящик в университете и нажмите ссылку для подтверждения.",
    "studentVerificationEmailFailed": "Не удалось отправить письмо с подтверждением. Пожалуйста, попробуйте еще раз.",
    "feedbackMessageRequired": "Введите сообщение обратной связи.",
    "feedbackTypeRequired": "Пожалуйста, выберите тип отзыва.",
    "feedbackThanks": "Спасибо, отзыв отправлен.",
    "feedbackSaveFailed": "Не удалось сохранить отзыв. Пожалуйста, попробуйте еще раз.",
    "feedbackType_general": "Общие сведения",
    "feedbackType_bug": "Ошибка",
    "feedbackType_feature": "Запрос функции",
    "feedbackType_event_issue": "Проблема с событием",
    "noSignedInUser": "Не найден ни один вошедший в систему пользователь.",
    "missingEmailForConfirmation": "В вашей учетной записи отсутствует адрес электронной почты для подтверждения пароля.",
    "enterPasswordToContinue": "Пожалуйста, введите свой пароль, чтобы продолжить.",
    "googleReauthUnavailable": "Повторная аутентификация Google недоступна в этой сборке.",
    "googleMissingIdToken": "Повторная аутентификация Google не вернула токен идентификатора.",
    "appleReauthUnavailable": "Повторная аутентификация Apple недоступна на этом устройстве.",
    "appleMissingIdentityToken": "Повторная аутентификация Apple не вернула идентификационный токен.",
    "deleteRequiresRecentLogin": "Пожалуйста, войдите еще раз, чтобы подтвердить удаление учетной записи.",
    "deleteInvalidCredential": "Этот пароль или учетные данные для входа не были приняты. Пожалуйста, попробуйте еще раз.",
    "deleteUserMismatch": "Пожалуйста, повторите аутентификацию, используя ту же учетную запись, с которой вы в данный момент вошли в Tonyte.",
    "deleteReauthInterrupted": "Повторная аутентификация прервана. Пожалуйста, попробуйте еще раз.",
    "deleteNetworkError": "Ошибка сети. Проверьте подключение и повторите попытку.",
    "deletePermissionDenied": "Разрешение отклонено. Пожалуйста, войдите в систему еще раз и попробуйте еще раз.",
    "deleteFailedAtStage": "Не удалось удалить учетную запись по адресу {stage}: {error}.",
    "deleteUnavailable": "Не удалось удалить вашу учетную запись прямо сейчас.",
    "signInAgainBeforeDelete": "Пожалуйста, войдите в систему еще раз, прежде чем удалять свою учетную запись.",
    "mustSignInToDelete": "Чтобы удалить свою учетную запись, вам необходимо войти в систему.",
    "accountCleanupFailed": "HTTP-запрос на очистку учетной записи не выполнен.",
    "selfieUnclear": "Селфи слишком маленькое или нечеткое. Пожалуйста, сделайте повторную съемку при хорошем освещении, чтобы было видно ваше лицо и жесты.",
    "selfieRequired": "Перед отправкой сделайте селфи для подтверждения.",
    "verificationSyncPending": "Подтверждение отправлено. Ожидается синхронизация статуса.",
    "verificationReviewFailed": "Проверка не удалась.",
    "vibeVerifiedApproved": "Одобрено Vibe Проверено для {user}.",
    "verificationClearSelfieFailed": "Проверка не удалась. Пожалуйста, повторите попытку и сделайте четкое селфи.",
    "revokeNotConfirmed": "Отзыв не подтвердил успех.",
    "shareTitle": "Tonyte Профиль",
    "shareMessage": "Посмотрите мой профиль Tonyte:\n{url}",
    "acceptSaveDomain": "Принять + сохранить домен",
    "tonyteUser": "Пользователь Tonyte",
    "verificationEmailSentTitle": "Письмо с подтверждением отправлено",
    "verificationPendingTitle": "Ожидается проверка",
    "verificationFailedTitle": "Проверка не удалась",
    "studentVerificationTitle": "Проверка учащихся",
    "verificationCheckInboxBody": "Пожалуйста, проверьте свой почтовый ящик и подтвердите, что это письмо принадлежит вам.",
    "verificationReviewingBody": "Мы проверяем ваш статус студента.",
    "verificationFailedBody": "Нам не удалось проверить ваш статус студента. Пожалуйста, проверьте электронную почту учащегося или повторите попытку.",
    "verificationUnlockBody": "Разблокируйте студенческие мероприятия, встречи Erasmus, ночную жизнь кампуса, мероприятия только для студентов, планы и чаты.",
    "studiZoneUnderConstruction": "StudiZone в разработке",
    "enterStudiZone": "Введите StudiZone",
    "verifyStudentStatus": "Проверка статуса учащегося",
    "faq1Question": "Что такое Tonyte?",
    "faq1Answer": "Tonyte помогает вам проводить мероприятия discover, присоединяться к планам и знакомиться с людьми поблизости во время путешествия или проживания в городе.",
    "faq2Question": "Tonyte бесплатен?",
    "faq2Answer": "Да, основные функции, такие как поиск событий, присоединение к планам и общение в чате, бесплатны.",
    "faq3Question": "Кто может видеть мой профиль?",
    "faq3Answer": "Пользователи могут видеть ваш профиль, когда вы взаимодействуете с ними через чаты, планы, мероприятия или ссылки на общий профиль.",
    "faq4Question": "Что такое план?",
    "faq4Answer": "План – это случайная встреча, созданная пользователем, например кофе, барбекю, осмотр достопримечательностей, игры или прогулка.",
    "faq5Question": "Кто может создавать планы?",
    "faq5Answer": "Любой вошедший в систему пользователь может создать план сообщества.",
    "faq6Question": "Что произойдет, если я присоединюсь к плану?",
    "faq6Answer": "Вы можете быть добавлены в список участников плана и получить доступ к чату плана.",
    "faq7Question": "Могу ли я отказаться от плана?",
    "faq7Answer": "Да, обычные участники могут покинуть план. Организаторы не могут покинуть свой план, если не удалят его.",
    "faq8Question": "Может ли организатор исключить меня из плана?",
    "faq8Answer": "Да. Организаторы могут удалять людей из собственных планов, чтобы обеспечить безопасность и комфорт.",
    "faq9Question": "Что произойдет, если меня исключит из плана?",
    "faq9Answer": "Вы не можете повторно присоединиться к этому плану, но вы все равно можете просматривать чат и при необходимости сообщать о плане или конкретных пользователях.",
    "faq10Question": "Кто может мне писать?",
    "faq10Answer": "Люди могут отправлять вам сообщения через матчи, чаты событий или чаты планирования.",
    "faq11Question": "Почему я не могу отправлять сообщения в чат?",
    "faq11Answer": "Возможно, вы больше не являетесь активным участником или вас удалили из этого плана/чата.",
    "faq12Question": "Могу ли я пожаловаться на кого-то?",
    "faq12Answer": "Да. Вы можете сообщать о пользователях, планах, событиях или поведении в чате, если что-то кажется вам небезопасным, оскорбительным, дискриминационным или неуместным.",
    "faq13Question": "Видно ли мое точное местоположение?",
    "faq13Answer": "Нет. Местоположение используется для отображения ближайших событий и планов. Ваше точное местоположение в реальном времени не отображается другим пользователям.",
    "faq14Question": "Могу ли я редактировать свой профиль?",
    "faq14Answer": "Да. Вы можете обновить свое имя, город, биографию, фотографии и интересы в любое время.",
    "faq15Question": "Как мне удалить свою учетную запись?",
    "faq15Answer": "Перейдите в «Настройки профиля» → «Удалить учетную запись».",
    "faq16Question": "Приложение работает неправильно. Что я должен делать?",
    "faq16Answer": "Используйте «Справку и обратную связь» в настройках и опишите проблему."
  },
  "vibes": {
    "synchronize": "Синхронизировать",
    "lockInToday": "Зафиксируйте сегодняшний vibe",
    "getYourVibesSynchronized": "Синхронизируйте свой Vibes",
    "getYourVibesSynchronizedFlat": "Синхронизируйте свой vibes",
    "vibeCircle": "Vibe Круг",
    "vibeAlignment": "Vibe Выравнивание",
    "sharedFrequency": "Общая частота",
    "instantSync": "Мгновенная синхронизация",
    "strongSync": "Сильная синхронизация",
    "recommendedVibe": "Рекомендуется Vibe",
    "openChat": "Открыть чат",
    "continueChat": "Продолжить чат",
    "sendVibe": "Отправить vibe",
    "startSync": "Начать синхронизацию",
    "pickAllHint": "Прямо сейчас выберите все, что подойдет вашему vibe.",
    "dontOverthink": "Не зацикливайтесь на этом.",
    "pickUpTo": "Забрать до",
    "couldNotSaveVibe": "Не удалось сохранить",
    "couldNotSaveVibeSub": "Пока не удалось сохранить ваш vibe. Пожалуйста, попробуйте еще раз.",
    "icebreakersReady": "В вашем чате готовы два ледокольных вопроса.",
    "suggestedIcebreaker": "Предлагаемый ледокол",
    "signalLocked": "сигнал заблокирован",
    "signalsLocked": "сигналы зафиксированы",
    "signalLockedCount_one": "Зафиксирован {count} сигнал",
    "signalLockedCount_few": "Зафиксировано {count} сигнала",
    "signalLockedCount_many": "Зафиксировано {count} сигналов",
    "signalLockedCount_other": "Зафиксировано {count} сигнала",
    "chooseOneSignal": "Выберите один сигнал",
    "chooseUpTo": "Выберите до",
    "next": "Далее",
    "microcopy0": "Не зацикливайтесь на этом.",
    "microcopy1": "Следуйте сегодняшней энергии.",
    "microcopy2": "Завтра всё может измениться.",
    "microcopy3": "Только текущий vibe.",
    "microcopy4": "Будьте честны.",
    "microcopy5": "Первый инстинкт обычно верен.",
    "dayVibesBadge": "ДЕНЬ VIBES",
    "questionOf": "Вопрос",
    "resultsUnlock1pm": "Результаты разблокируются в 1:00 PM",
    "lastOne": "Последний!",
    "questionsLeft": "остались вопросы",
    "questionLeft": "остался вопрос",
    "questionLeftCount_one": "Остался {count} вопрос",
    "questionLeftCount_few": "Осталось {count} вопроса",
    "questionLeftCount_many": "Осталось {count} вопросов",
    "questionLeftCount_other": "Осталось {count} вопроса",
    "openAt6am": "Сегодняшнее сканирование aura начинается в 6:00 AM.",
    "resetDaily": "Свежие вопросы и результаты Vibe Circle сбрасываются с наступлением нового дня.",
    "loadingAura": "Загрузка сегодняшнего aura...",
    "noAuraToday": "На сегодня aura не найдено.",
    "goBack": "Вернуться назад",
    "todaysAura": "Сегодняшний Aura",
    "todayYouAre": "СЕГОДНЯ ТЫ",
    "resultsIn": "Результат:",
    "basedOnToday": "По данным сегодняшнего дня Vibes",
    "findingWavelength": "Поиск людей на вашей волне...",
    "noAlignmentYet": "Пока нет выравнивания Vibe",
    "noAlignmentSubtitle": "Пока никто на вашей волне не закончил сегодняшнюю игру. Новые совпадения могут появиться, когда сыграют другие, — они появятся здесь автоматически.",
    "firstVibesUnlock": "Вы в игре! Первые вайбы откроются в 13:00.",
    "moreMatchesLater": "Новые совпадения могут появиться, когда присоединятся другие, — ваш Круг Vibe обновляется весь день.",
    "matchingInProgress": "Ищем ваши вайбы…",
    "matchingInProgressBody": "Сравниваем вас со всеми, кто играл сегодня. Обновится само.",
    "matchingRetryingBody": "Это занимает чуть больше времени, чем обычно, — мы уже работаем. Ваши вайбы появятся здесь автоматически.",
    "moreCanArrive": "Новые вайбы могут появиться, когда другие закончат сегодняшнюю игру.",
    "resultsRightAway": "Результаты сразу после игры",
    "refresh": "Обновить",
    "sync": "синхронизация",
    "sharedFrequencyToday": "общая частота сегодня",
    "sharedFrequenciesToday": "общие частоты сегодня",
    "alignmentPercentPrefix": "Ваше мировоззрение vibe",
    "icebreakerPrompt1": "Чему вы оба искренне сказали бы сегодня «да»?",
    "icebreakerPrompt2": "Какая настройка облегчит работу общего vibe?",
    "auraCitySoulName": "Душа города",
    "auraCitySoulDescription": "Сегодня вы излучаете любопытную, кинематографическую и спокойную авантюрную энергию.",
    "auraCitySoulTrait1": "Исследователь города",
    "auraCitySoulTrait2": "Мягкие социальные сети",
    "auraCitySoulTrait3": "Эстетическое настроение",
    "auraSoftChaosName": "Мягкий хаос",
    "auraSoftChaosDescription": "Спонтанные планы, социальные искры и прекрасная неструктурированная энергия.",
    "auraSoftChaosTrait1": "Спонтанно",
    "auraSoftChaosTrait2": "Кафе Хоппер",
    "auraSoftChaosTrait3": "Социальные сети сегодня",
    "auraGoldenHourName": "Золотой час",
    "auraGoldenHourDescription": "Теплый, неторопливый и светящийся намеренным присутствием сегодня.",
    "auraGoldenHourTrait1": "Намеренно",
    "auraGoldenHourTrait2": "Искатель тепла",
    "auraGoldenHourTrait3": "Настоящий момент",
    "auraNeonWolfName": "Неоновый волк",
    "auraNeonWolfDescription": "Смелый, заряженный и работающий сегодня на независимой электрической энергии.",
    "auraNeonWolfTrait1": "Независимый",
    "auraNeonWolfTrait2": "Электрически жирный",
    "auraNeonWolfTrait3": "Готовность к ночному режиму",
    "auraQuietStormName": "Тихий шторм",
    "auraQuietStormDescription": "Глубоко присутствующий, творчески живой и тихий мощный сегодня.",
    "auraQuietStormTrait1": "Интроспективный",
    "auraQuietStormTrait2": "Творческий подход",
    "auraQuietStormTrait3": "Глубоко в курсе",
    "auraSolarBurstName": "Солнечная вспышка",
    "auraSolarBurstDescription": "Сегодня сияющая, притягательная и переполненная внешней энергией.",
    "auraSolarBurstTrait1": "Высокая энергия",
    "auraSolarBurstTrait2": "Сияюще открытое",
    "auraSolarBurstTrait3": "Магнетически социальный",
    "reset": "Сброс",
    "scan": "Сканирование",
    "auraBadgeAccessibility": "Значок {name} aura",
    "auraBadgeHint": "Расширение сегодняшнего описания aura."
  },
  "venues": {
    "vibeAtVenues": "Vibe на площадках"
  },
  "imageCrop": {
    "profilePhoto": "Фото профиля",
    "eventPhoto": "Фото события",
    "coverPhoto": "Фото обложки",
    "frameProfile": "Настройте фото профиля",
    "frameEvent": "Настройте фото события",
    "frameCover": "Настройте фото обложки",
    "previewBeforeSaving": "Проверьте изображение перед сохранением.",
    "dragToReposition": "Перетащите фото, чтобы изменить положение",
    "fitEntireImage": "Показать всё изображение",
    "cropToFill": "Обрезать по размеру",
    "completeImageHint": "Будет сохранено полное изображение",
    "viewFullImage": "Открыть полное изображение события",
    "zoom": "Масштаб",
    "cropping": "Обрезка...",
    "useImage": "Использовать фото"
  },
  "appUpdate": {
    "defaultTitle": "Tonyte стал ещё лучше",
    "defaultMessage": "Мы улучшили карты, планы, профили и общее впечатление от приложения.",
    "newVersion": "Доступна новая версия",
    "newVersionNamed": "Доступна новая версия {version}",
    "opening": "Открываем...",
    "updateNow": "Обновить сейчас",
    "optionalTitle": "Обновите Tonyte 🧡",
    "optionalMessage": "Доступна новая версия с последними функциями, исправлениями и улучшениями.",
    "requiredTitle": "Tonyte нужно обновить",
    "requiredMessage": "Пожалуйста, обновите Tonyte, чтобы продолжить пользоваться приложением.",
    "updateTonyte": "Обновить Tonyte",
    "notNow": "Не сейчас"
  },
  "languages": {
    "en": "английский",
    "de": "Немецкий",
    "es": "Испанский",
    "fr": "Французский",
    "ru": "Русский"
  },
  "onboarding": {
    "languageTitle": "Выберите ваш язык",
    "languageSub": "Отныне Tonyte будет говорить на вашем языке. Вы можете изменить это в любой момент в Настройках.",
    "travelerProfile": "Ваш профиль путешественника",
    "displayNameTitle": "Как вас следует называть путешественникам?",
    "displayNameSub": "Выберите имя, которое вам подходит.",
    "displayNameLabel": "ОТОБРАЖАЕМОЕ ИМЯ",
    "displayNamePlaceholder": "Ваше отображаемое имя",
    "changeLater": "Вы можете изменить это позже.",
    "continue": "Продолжить",
    "photoTitle": "Добавьте лицо в свой профиль",
    "photoSub": "Изображение профиля помогает другим узнать, с кем они встречаются.",
    "tapUpload": "Нажмите, чтобы загрузить",
    "addPhoto": "Добавить изображение профиля",
    "skipNow": "Пропустить сейчас",
    "dobTitle": "Какая у тебя дата рождения?",
    "dobSub": "Это помогает Tonyte поддерживать планы и открытия в соответствии с возрастом.",
    "dobLabel": "ДАТА РОЖДЕНИЯ",
    "invalidDob": "Пожалуйста, выберите правильную дату рождения.",
    "dobReady": "Дата рождения добавлена — теперь можно продолжить.",
    "continueLocked": "Продолжить · укажите дату",
    "interests": "Интересы",
    "selected20": "{count}/20 выбрано",
    "unlockStudiZone": "Разблокировать StudiZone",
    "unlockStudiZoneSub": "Подтвердите свой статус студента, чтобы получить доступ к мероприятиям только для студентов, планам Erasmus, сообществам кампуса и частным студенческим чатам.",
    "campusEvents": "Мероприятия в кампусе",
    "erasmusPlans": "Планы Erasmus",
    "studentChats": "Студенческие чаты",
    "verifiedGuestlist": "Проверенный список гостей",
    "universityEmail": "ЭЛЕКТРОННАЯ ПОЧТА УНИВЕРСИТЕТА",
    "universityEmailPlaceholder": "your@university.edu",
    "universityEmailHelp": "Введите адрес электронной почты вашего университета для проверки администратором. Никакого спама, никогда.",
    "submitVerification": "Отправить на проверку",
    "skipVerification": "Пропустить сейчас — подтвердите позже в профиле",
    "guidelinesTitle": "Правила сообщества",
    "guidelinesSub": "Tonyte построен на доверии и уважении. Прочтите и согласитесь, прежде чем присоединиться.",
    "guidelineRespect": "Относитесь с уважением к каждому путешественнику — онлайн и лично.",
    "guidelineHarassment": "Абсолютная нетерпимость к преследованиям, разжиганию ненависти или оскорблениям.",
    "guidelineRealEvents": "Публикуйте только реальные и точные события и планы.",
    "guidelineSafety": "При всех встречах уделяйте приоритетное внимание безопасности.",
    "guidelineData": "Ваши данные защищены. Мы не продаем вашу информацию.",
    "guidelineReport": "Сообщите о вредоносном контенте, используя кнопку флажка в приложении.",
    "viewTerms": "Посмотреть Условия использования",
    "viewPrivacy": "Посмотреть политику конфиденциальности",
    "agreeTerms": "Я согласен с Условиями обслуживания и Принципами сообщества.",
    "enterTonyte": "Введите Tonyte →",
    "skipPhotoTitle": "Пропустить изображение профиля?",
    "skipPhotoBody": "Без изображения профиля вы не сможете получить доступ ко всем функциям, таким как Discover, присоединение к планам или создание планов.",
    "uploadPicture": "Загрузить изображение",
    "skipAnyway": "Все равно пропустить",
    "displayNameMin": "Отображаемое имя должно содержать не менее 2 символов.",
    "displayNameSaveFailed": "Не удалось сохранить отображаемое имя.",
    "choosePhoto": "Выберите изображение профиля или пропустите его.",
    "photoSaveFailed": "Не удалось сохранить изображение профиля.",
    "photoSkipFailed": "Не удалось пропустить изображение профиля.",
    "dobRequired": "Введите дату своего рождения, чтобы продолжить.",
    "ageRequirement": "Tonyte предназначен для путешественников в возрасте {age} и старше. Пожалуйста, проверьте дату вашего рождения.",
    "profileSaveFailed": "Не удалось сохранить профиль.",
    "verificationSendFailed": "Не удалось отправить письмо с подтверждением. Проверьте адрес и повторите попытку.",
    "skipFailed": "Не удалось пропустить.",
    "acceptTerms": "Чтобы продолжить, примите Условия и правила сообщества.",
    "setupFailed": "Не удалось завершить настройку.",
    "themeKicker": "СДЕЛАЙТЕ TONYTE СВОИМ",
    "themeTitle": "Выберите свой стиль",
    "themeSubtitle": "Выберите сторону Tonyte, которая вам ближе.",
    "themeDaylight": "ДНЕВНОЙ",
    "themeDaylightDescriptor": "Светлый · Тёплый · Общительный",
    "themeMidnight": "ПОЛНОЧНЫЙ",
    "themeMidnightDescriptor": "Тёмный · Смелый · Энергичный",
    "themeSwitchAnytime": "Тему можно изменить в любое время в Профиле.",
    "themeNotPermanent": "Выбор не навсегда — меняйте тему в Профиле в любое время.",
    "themeEnter": "Войти в Tonyte",
    "selectThemeRequired": "Выберите Дневную или Полночную тему, чтобы войти в Tonyte."
  },
  "library": {
    "myPosts": "Мои сообщения",
    "profileEyebrow": "ПРОФИЛЬ",
    "events": "события",
    "plans": "планы",
    "search": "Поиск по названию, месту проведения, городу, тегам…",
    "loadingPosts": "Загрузка сообщений…",
    "edit": "Править",
    "repost": "Репост",
    "planEditing": "Редактирование плана",
    "planEditingUnavailable": "Редактирование плана пока недоступно.",
    "permissionRequired": "Требуется разрешение",
    "deletePermission": "Только организатор мероприятия или администраторы могут удалить это сообщение.",
    "deletePost": "Удалить сообщение",
    "deletePostFailed": "Не удалось удалить сообщение. Попробуйте еще раз.",
    "organizerLibrary": "БИБЛИОТЕКА ОРГАНИЗАТОРА",
    "savedTemplates": "Сохраненные шаблоны",
    "loadingTemplates": "Загрузка шаблонов…",
    "eventTemplate": "ШАБЛОН СОБЫТИЯ",
    "useTemplate": "Использовать шаблон",
    "deleteTemplate": "Удалить шаблон",
    "deleteTemplateFailed": "Не удалось удалить шаблон. Попробуйте еще раз.",
    "deleteConfirm": "Удалить \"{title}\"? Это невозможно отменить.",
    "noMatches": "Нет совпадений",
    "noPosts": "Пока нет сообщений",
    "searchAgain": "Попробуйте другой поисковый запрос.",
    "noPostsSub": "Чтобы начать, создайте план мероприятия или сообщества.",
    "communityPlan": "ПЛАН СООБЩЕСТВА",
    "officialEvent": "ОФИЦИАЛЬНОЕ СОБЫТИЕ",
    "noTemplates": "Нет сохраненных шаблонов",
    "noTemplatesSub": "Создайте событие и сохраните его как шаблон для быстрого повторного использования.",
    "untitled": "Без названия",
    "noVenue": "Нет места проведения"
  },
  "planRequests": {
    "empty": "Нет ожидающих запросов",
    "emptySub": "Здесь появятся запросы на присоединение из ваших планов сообщества.",
    "new": "НОВИНКА",
    "noMessage": "Нет сообщения",
    "decline": "Отказ",
    "accept": "Принять",
    "acceptFailed": "Не удалось принять запрос. Пожалуйста, попробуйте еще раз.",
    "declineFailed": "Не удалось отклонить запрос. Пожалуйста, попробуйте еще раз.",
    "studiZoneAdmin": "STUDIZONE АДМИН",
    "planAdmin": "АДМИНИРОВАНИЕ ПЛАНА",
    "studiZoneRequests": "StudiZone Запросы",
    "joinRequests": "Запросы на присоединение",
    "traveler": "Путешественник",
    "communityPlan": "План сообщества",
    "viewProfile": "Посмотреть профиль",
    "profileUnavailable": "Профиль недоступен",
    "profileUnavailableBody": "Не удалось найти профиль этого пользователя."
  },
  "publicProfile": {
    "reportFailed": "Не удалось отправить отчет.",
    "blockTitle": "Заблокировать пользователя?",
    "blockFailed": "Не удалось заблокировать пользователя",
    "profileUnavailableTitle": "Профиль недоступен",
    "profileUnavailableBody": "Этот профиль больше не существует или сейчас недоступен.",
    "vibeScore": "VIBE ОЦЕНКА",
    "match": "% совпадений",
    "unvibe": "Отключите Vibe",
    "report": "Отчет",
    "about": "О нас",
    "publicPlans": "Общественные планы",
    "publicEvents": "Публичные мероприятия",
    "safetyHint": "Действия по жалобе и блокировке доступны из меню прямого чата.",
    "safety": "БЕЗОПАСНОСТЬ",
    "optionalDetails": "Дополнительные сведения...",
    "unvibeWith": "Отключиться от {name}?",
    "unvibeBody": "Это приведет к удалению вашего соединения и прямого чата.",
    "keepVibe": "Держите Vibe",
    "community": "Сообщество Tonyte",
    "reportSubmitted": "Отчет отправлен",
    "blockMessage": "Вы больше не будете видеть сообщения от {name}. Блокировка является односторонней и не будет уведомлять их.",
    "userBlocked": "Пользователь заблокирован",
    "vibeSent": "Vibe отправлен на {name}",
    "vibeSendFailed": "Не удалось отправить vibe",
    "noLongerVibing": "Вы и {name} больше не общаетесь",
    "unvibeFailed": "Не удалось отключить прямо сейчас",
    "message": "Сообщение",
    "vibeSentStatus": "Vibe Отправлено",
    "sendVibe": "Отправить Vibe",
    "blocking": "Блокировка...",
    "block": "Блокировать",
    "reportPerson": "Отчет {name}",
    "sending": "Отправка...",
    "submitReport": "Отправить отчет",
    "removing": "Удаление...",
    "reasonSpam": "Спам",
    "reasonHarassment": "Преследование",
    "reasonFake": "Фальшивый профиль",
    "reasonContent": "Неприемлемый контент",
    "reasonScam": "Мошенничество или небезопасное поведение",
    "reasonOther": "Другое",
    "eventFallback": "Событие",
    "planFallback": "План"
  },
  "promotions": {
    "sectionTitle": "Подборки",
    "explore": "Смотреть события",
    "eventsCount": "Событий: {count}",
    "collection": "Подборка",
    "runs": "{range}",
    "dateRangeNote": "События за весь этот период, а не только в выбранный в ленте день.",
    "unavailableTitle": "Подборка недоступна",
    "unavailableSub": "Возможно, она закончилась или была удалена. Посмотрите ленту событий.",
    "backToEvents": "К событиям"
  },
  "studiZone": {
    "locked": "StudiZone Заблокировано",
    "lockedSub": "Подтвердите свой статус студента, чтобы разблокировать студенческие мероприятия, встречи Erasmus, планы кампуса и ночную жизнь университета.",
    "verifyStatus": "Проверка статуса учащегося",
    "underConstruction": "в разработке",
    "constructionSub": "Мы наносим последние штрихи на StudiZone. Ваш подтвержденный статус сохранен — вы получите полный доступ после его запуска.",
    "verifiedLayer": "Слой проверенного ученика",
    "exit": "Выход",
    "loading": "Загрузка StudiZone...",
    "createPlan": "Создать студенческий план",
    "planChat": "План чата StudiZone · Участники {count}",
    "unlockedSub": "Для этого профиля доступны только студенческие планы, чаты и ночная жизнь кампуса.",
    "planRequests": "Планирование запросов",
    "soon": "Скоро",
    "campusMap": "Карта кампуса",
    "studentPins": "{count} студенческие значки",
    "openMap": "Открыть полную карту",
    "emptyLane": "На этом переулке пока ничего нет",
    "emptyLaneSub": "StudiZone готов к выпуску только для студентов, обществ, студенческих мероприятий и планов Erasmus.",
    "loadingMap": "Загрузка карты ученика...",
    "mapTitle": "Карта кампуса",
    "pins": "Контакты StudiZone",
    "tonyteStudent": "Tonyte Студент",
    "studentDiscounts": "Скидки для студентов",
    "universityCommunities": "Университетские сообщества",
    "societiesClubs": "Общества и клубы",
    "campusHeatmaps": "Тепловые карты кампуса",
    "categoryAll": "Все",
    "categoryCampus": "Кампус",
    "categoryParties": "Вечеринки",
    "categoryErasmus": "Erasmus",
    "categoryWorkshops": "Семинары",
    "categorySports": "Спорт",
    "categoryFree": "Бесплатно",
    "tabFeed": "Лента",
    "hey": "Привет, {name}",
    "upcoming": "Скоро",
    "eventsCount": "Событий: {count}",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "free": "Бесплатно",
    "verified": "Подтверждено",
    "timeTba": "Время уточняется",
    "campusMapSub": "Смотри, что происходит у кампуса",
    "searchUniversities": "Поиск вузов",
    "dresden": "Дрезден",
    "campusEventsCount": "Событий на кампусе: {count}",
    "noCampusEvents": "На этом кампусе пока нет событий",
    "noCampusEventsSub": "Здесь появятся события, привязанные к зданиям кампуса.",
    "buildingFilter": "Корпус {code}",
    "noUniversityResults": "Вуз не найден",
    "yourUniversity": "Твой вуз",
    "campusesCount": "Кампусов: {count}",
    "allEvents": "Все события StudiZone",
    "tabPlans": "Планы",
    "tabChats": "Чаты",
    "tabProfile": "Профиль"
  },
  "verification": {
    "signInSub": "Пожалуйста, войдите в систему, чтобы начать проверку.",
    "title": "Центр проверки",
    "subtitle": "Управляйте значками доверия и дополнительным доступом к StudiZone из одного места.",
    "vibe": "Vibe Проверка",
    "retake": "Повторная съемка",
    "student": "Проверка учащихся",
    "emailPlaceholder": "name@university.edu",
    "backToTonyte": "Назад к Tonyte",
    "validStudentEmail": "Введите действительный адрес электронной почты учащегося.",
    "emailSent": "Письмо с подтверждением отправлено. Проверьте свой университетский почтовый ящик.",
    "emailSendFailed": "Не удалось отправить письмо с подтверждением.",
    "selfieTooSmall": "Селфи слишком маленькое или нечеткое. Сделайте повторную съемку при хорошем освещении, чтобы было видно ваше лицо.",
    "submitted": "Отправлено на рассмотрение.",
    "submitFailed": "Не удалось отправить подтверждение.",
    "verified": "Проверено",
    "pending": "Ожидается",
    "failed": "Ошибка",
    "notVerified": "Не проверено",
    "vibeDescription": "Значок доверия и безопасности, показывающий другим людям, что ваш профиль принадлежит реальному человеку. Ваше селфи для проверки проверяется вручную и удаляется после принятия решения о проверке.",
    "studentDescription": "Дополнительная проверка для людей, которым нужен доступ к StudiZone. Это не меняет основного опыта Tonyte.",
    "pendingReview": "Ожидается проверка",
    "tryAgain": "Попробуйте еще раз",
    "start": "Начать проверку",
    "submitting": "Отправка...",
    "submitReview": "Отправить на рассмотрение",
    "poseGuideTitle": "Подтвердите свой Vibe",
    "poseGuideBody": "Быстрая проверка лица\n\nМы автоматически сделаем три фото:\n• Смотрим прямо перед собой\n• Смотрим налево\n• Смотрим направо\n\nУбедитесь, что ваше лицо хорошо видно и вы находитесь при хорошем освещении.\n\nВаши фото надёжно передаются на проверку и могут быть рассмотрены командой Tonyte.",
    "poseGuideOpenCamera": "Продолжить",
    "camera": {
      "requestingPermission": "Запрос доступа к камере…",
      "permissionDenied": "Для проверки Vibe нужен доступ к камере. Включите его в настройках и попробуйте снова.",
      "openSettings": "Открыть настройки",
      "onePersonOnly": "В кадре должен быть только один человек",
      "of": "из",
      "moveIntoFrame": "Расположите лицо в кадре",
      "lookStraight": "Смотрите прямо в камеру",
      "turnLeft": "Покажите свой левый профиль",
      "turnRight": "Теперь покажите свой правый профиль",
      "holdStill": "Не двигайтесь…",
      "faceDetected": "Лицо обнаружено ✓",
      "frontCaptured": "✓ Анфас снят",
      "leftCaptured": "✓ Левый профиль снят",
      "rightCaptured": "✓ Правый профиль снят",
      "verificationComplete": "Вы прошли Vibe проверку ✓",
      "uploading": "Загрузка ваших фото…",
      "fallbackMessage": "Не удалось проверить автоматически. Вы можете отправить фото на ручную проверку.",
      "fallbackSubmit": "Отправить на ручную проверку",
      "tryAgain": "Попробовать снова",
      "errorGeneric": "Не удалось завершить проверку. Убедитесь, что ваше лицо хорошо видно, и попробуйте снова."
    }
  },
  "uploadPlan": {
    "signInBody": "Прежде чем создавать план, войдите в систему.",
    "missingDetails": "Отсутствуют детали",
    "missingDetailsBody": "Добавьте название и описание плана.",
    "missingLocation": "Отсутствует местоположение",
    "missingLocationBody": "Добавьте место и город встречи.",
    "missingDate": "Отсутствует дата",
    "missingDateBody": "Выберите дату и время начала.",
    "participantLimit": "Лимит участников",
    "participantLimitBody": "Максимальное количество участников плана должно быть не менее 2.",
    "safetySetup": "Настройка безопасности",
    "safetySetupBody": "Перед публикацией примите на себя ответственность за безопасность.",
    "invalidDate": "Неверная дата",
    "futureDate": "Пожалуйста, выберите сегодняшнюю или будущую дату.",
    "invalidTime": "Недопустимое время",
    "pastTime": "Время начала не может быть в прошлом.",
    "publishFailed": "Не удалось опубликовать план.",
    "back": "← Назад",
    "communityPlan": "План сообщества",
    "createPlan": "Создать план",
    "alwaysFree": "Планы всегда бесплатны.",
    "alwaysFreeBody": "Планы сообщества не поддерживают платежи или билеты.",
    "title": "Название плана",
    "description": "Описание плана",
    "city": "Город",
    "cityHelp": "Планы отображаются только внутри выбранного города.",
    "chooseCity": "Выберите свой город",
    "dateRange": "Диапазон дат",
    "dateRangeHelp": "Помогите другим узнать, когда и где встретиться.",
    "location": "Местоположение",
    "locationPlaceholder": "Где люди должны встречаться?",
    "dateFrom": "Дата с",
    "timeFrom": "Время с",
    "safety": "Настройка безопасности",
    "safetyHelp": "Помогите другим понять, к какому плану они присоединяются.",
    "hostedAt": "Размещено по адресу",
    "hostedHelp": "Выберите, будет ли этот план размещаться в публичном, частном или неизвестном месте.",
    "visibility": "Видимость плана",
    "visibilityHelp": "Выберите, кто может discover использовать этот план.",
    "maxParticipants": "Максимальное количество участников (необязательно)",
    "unlimited": "Оставьте пустым для неограниченного количества",
    "responsibility": "Я понимаю, что несу ответственность за создание безопасного и уважительного плана.",
    "publish": "План публикации",
    "publicPlace": "Общественное место",
    "privatePlace": "Частное место",
    "unknown": "Неизвестно",
    "public": "Публичный",
    "friends": "Друзья",
    "inviteOnly": "Только по приглашению",
    "startedFromTemplate": "Создано на основе шаблона Tonyte",
    "endsAt": "План заканчивается",
    "endsAtHelp": "После этого времени план исчезнет из Tonyte и затем будет удалён автоматически.",
    "endDate": "Дата окончания",
    "endTime": "Время окончания",
    "missingEnd": "Не указано время окончания",
    "missingEndBody": "Выберите, когда заканчивается план.",
    "endBeforeStart": "План должен заканчиваться после начала.",
    "endTooLate": "План может длиться не более 14 дней."
  },
  "uploadEvent": {
    "signInBody": "Войдите в систему перед публикацией мероприятия.",
    "missingDetails": "Отсутствуют детали",
    "missingDetailsBody": "Добавьте название и описание события.",
    "missingDate": "Отсутствует дата",
    "missingDateBody": "Выберите дату и время начала.",
    "participantLimit": "Лимит участников",
    "participantLimitBody": "Введите 0 для неограниченного количества участников или лимита участников больше 0.",
    "invalidDate": "Неверная дата",
    "futureDate": "Пожалуйста, выберите сегодняшнюю или будущую дату.",
    "invalidTime": "Недопустимое время",
    "startPast": "Время начала не может быть в прошлом.",
    "endBeforeStart": "Дата окончания не может быть раньше даты начала.",
    "endTimeBeforeStart": "Время окончания должно быть позже времени начала.",
    "untilBeforeStart": "Дата до не может быть раньше даты начала мероприятия.",
    "tagRequired": "Требуется тег события",
    "tagRequiredBody": "Выберите хотя бы один тег события, чтобы люди могли discover ваше мероприятие.",
    "permissionRequired": "Требуется разрешение",
    "editPermission": "Только администраторы, соадмины и организатор мероприятия могут редактировать это мероприятие.",
    "addressWarning": "Нам не удалось проверить этот точный адрес, но мы сохраним его в том виде, в котором он был введен.",
    "publishFailed": "Не удалось опубликовать мероприятие",
    "back": "← Назад",
    "officialEvent": "Официальное мероприятие",
    "editEvent": "Редактировать событие",
    "repostEvent": "Репост события",
    "fromTemplate": "Новое из шаблона",
    "createEvent": "Создать событие",
    "addCover": "Добавить обложку",
    "invalidImage": "Недопустимое изображение события",
    "imageTooLarge": "Выберите изображение меньше 15 МБ.",
    "unsupportedImage": "Выберите изображение JPEG, PNG, WebP, HEIC или HEIF.",
    "title": "Название события",
    "description": "Описание события",
    "venueOrganizer": "Место проведения/организатор",
    "lineup": "Состав/ведущие (через запятую)",
    "websiteUrl": "URL-адрес веб-сайта",
    "instagramUrl": "URL-адрес Instagram",
    "sourceUrl": "URL-адрес страницы события/источника",
    "location": "Местоположение",
    "locationHelp": "Найдите место или адрес. Выберите из предложенных вариантов, чтобы закрепить мероприятие на карте.",
    "city": "Город",
    "cityHelp": "События отображаются только внутри выбранного города.",
    "dateRange": "Диапазон дат",
    "dateRangeHelp": "Установите окно даты и времени публичного мероприятия.",
    "dateFrom": "Дата с",
    "dateTo": "Дата",
    "timeFrom": "Время с",
    "timeTo": "Пора",
    "lastEntry": "Время последнего входа",
    "lastEntryHelp": "Скрыть это событие из списка «Текущие» после этого времени, даже если оно закончится позже.",
    "eventTags": "ТЕГИ СОБЫТИЙ",
    "tagsHelp": "Выберите все подходящие · хотя бы один обязательный",
    "maxParticipants": "Максимальное количество участников",
    "maxParticipantsHelp": "Введите 0 для неограниченного количества участников.",
    "maxParticipantsPlaceholder": "Максимальное количество участников",
    "freeEvent": "Бесплатное мероприятие",
    "freeEventHelp": "В текущей сборке Tonyte все мероприятия бесплатны.",
    "saveTemplate": "Сохранить как шаблон",
    "saveTemplateHelp": "Сохраните эту полную публикацию о мероприятии для будущих загрузок.",
    "saveCurrentTemplate": "Сохранить текущие поля как шаблон",
    "recurring": "Повторяющееся событие",
    "recurringHelp": "Используйте поля шаблона и создайте несколько экземпляров событий.",
    "oneTime": "Одноразовое событие",
    "weekly": "Еженедельно",
    "custom": "Пользовательский",
    "repeatEvery": "Повторять каждый",
    "until": "Пока",
    "occurrences": "События",
    "customDates": "Даты произвольных событий",
    "customDatesHelp": "Даты, разделенные запятыми, например. 15 июня 2026 г., 22 июня 2026 г.",
    "skipDates": "Пропустить даты",
    "skipDatesHelp": "Даты, разделенные запятыми, которые нужно пропустить.",
    "saveEvent": "Сохранить событие",
    "publishRepost": "Публикация Репост",
    "publishEvent": "Событие публикации",
    "selectCity": "Выберите город",
    "locationRequired": "Требуется местоположение",
    "locationRequiredBody": "Найдите и выберите место из предложенных, чтобы ваше мероприятие появилось на карте.",
    "ok": "ОК",
    "hashtags": "Хэштеги",
    "selected": "выбрано",
    "addHashtags": "Добавьте хэштеги",
    "collapseHashtags": "Свернуть хэштеги",
    "hashtagsHelp": "Найдите или добавьте хэштеги событий. Разделяйте несколько хештегов запятыми."
  },
  "venueProfiles": {
    "open": "Открыть",
    "mapUnavailable": "Карта недоступна",
    "noAddress": "Это место еще не имеет адреса.",
    "mapOpenFailed": "Не удалось открыть карту.",
    "followers": "Последователи",
    "posts": "Сообщения",
    "events": "События",
    "upcoming": "Предстоящие",
    "past": "Прошлое",
    "about": "О нас",
    "calendar": "Календарь",
    "noEventsOnDay": "В этот день нет событий.",
    "yourVenue": "Ваш профиль",
    "editProfile": "Редактировать профиль",
    "editLoadFailed": "Не удалось загрузить профиль",
    "editSaveFailed": "Не удалось сохранить изменения",
    "editNotAllowed": "Редактировать профиль может только владелец.",
    "coverPhoto": "Обложка",
    "profilePhoto": "Фото профиля",
    "changePhoto": "Изменить",
    "coverHint": "Перетаскивайте, чтобы сдвинуть, и сводите пальцы или используйте ползунок для масштаба. Именно так фото будет выглядеть в профиле и в Vibe at Venues.",
    "adjustPhoto": "Настроить",
    "bioLabel": "Описание",
    "bioPlaceholder": "Расскажите о вашем месте",
    "categoryLabel": "Категория",
    "dashboard": "Панель аналитики",
    "analytics": "Аналитика",
    "calendarImports": "Импорт календаря",
    "unavailable": "Этот профиль недоступен.",
    "calendarImportsSub": "Проверьте и опубликуйте импортированные события",
    "dashboardSub": "Просмотры, интерес, репосты и эффективность событий",
    "follow": "Следовать",
    "following": "Подписка",
    "organizerNotFound": "Организатор не найден",
    "organizerUnavailable": "Этот профиль организатора пока недоступен.",
    "vibesTitle": "Vibe на площадках",
    "vibesSubtitle": "Найдите места, где собираются ваши люди.",
    "search": "Поиск площадок, клубов, кафе, баров...",
    "refreshFailed": "Не удалось обновить сообщения о местах проведения. Показываю то, что имеется.",
    "noVenues": "Площадки не найдены",
    "noVenuesSub": "Попробуйте другой поиск или категорию.",
    "signInFollowVenue": "Войдите в систему перед следующими местами.",
    "signInFollowOrganizer": "Войдите в систему, прежде чем подписываться на организаторов.",
    "signInLike": "Войдите в систему, прежде чем лайкать публикации о местах проведения.",
    "signInComment": "Войдите в систему, прежде чем комментировать сообщения о местах проведения.",
    "signInDeleteComment": "Прежде чем удалять комментарии, войдите в систему.",
    "notAllowed": "Не разрешено",
    "ownCommentsOnly": "Вы можете удалять только свои комментарии."
  },
  "verificationComplete": {
    "noToken": "Токен подтверждения не найден. Пожалуйста, используйте ссылку из вашего электронного письма.",
    "couldNotComplete": "Не удалось завершить проверку.",
    "expiredBody": "Срок действия этой ссылки истек. Пожалуйста, запросите новое письмо с подтверждением в приложении.",
    "invalidBody": "Эта ссылка для проверки недействительна или уже использовалась.",
    "verifying": "Проверка…",
    "verified": "Адрес электронной почты студента подтвержден",
    "underReview": "На рассмотрении",
    "expired": "Срок действия ссылки истек",
    "invalid": "Неверная ссылка",
    "failed": "Проверка не удалась",
    "checking": "Проверка подтверждения электронной почты учащегося…",
    "verifiedUniversity": "Электронная почта учащегося подтверждена. Добро пожаловать в StudiZone. Ваш статус студента {university} подтвержден.",
    "verifiedWelcome": "Адрес электронной почты учащегося подтвержден. Добро пожаловать в StudiZone.",
    "pendingBody": "Право собственности на адрес электронной почты подтверждено. Ваше подтверждение учащегося ожидает рассмотрения.",
    "back": "Назад к Tonyte"
  },
  "permissions": {
    "locationTitle": "Использовать свое местоположение?",
    "locationMessage": "Tonyte использует ваше местоположение, чтобы показывать ближайшие события и планы.",
    "notificationsTitle": "Включить уведомления?",
    "notificationsMessage": "Tonyte использует уведомления о новых сообщениях, обновлениях планов и напоминаниях о событиях.",
    "cameraTitle": "Используете камеру?",
    "cameraMessage": "Tonyte использует вашу камеру, когда вы решаете делать фотографии для своего профиля, мероприятий, планов или проверки лица.",
    "microphoneTitle": "Используете микрофон?",
    "microphoneMessage": "Tonyte требуется доступ к микрофону для отправки голосовых заметок.",
    "locationLabel": "местоположение",
    "notificationsLabel": "уведомления",
    "cameraLabel": "камера",
    "microphoneLabel": "микрофон",
    "disabled": "Разрешение отключено",
    "notGranted": "Разрешение не предоставлено",
    "blockedBody": "Tonyte не имеет доступа к вашему {permission}. Вы можете включить его в настройках.",
    "deniedBody": "Вы можете продолжить без доступа к {permission}. Некоторые функции могут быть ограничены."
  },
  "notifications": {
    "newJoinRequest": "Новый запрос на присоединение",
    "newJoinRequestBody": "У вас есть новый запрос на присоединение.",
    "planAccepted": "Вы в деле 🎉",
    "planAcceptedBody": "Вас приняли в план.",
    "newVibeRequest": "Новый запрос Vibe ✨",
    "newVibeRequestBody": "Кто-то хочет с вами вайбить.",
    "vibeAccepted": "Это Vibe ✨",
    "vibeAcceptedBody": "Ваш запрос Vibe был принят.",
    "eventsTitle": "Что происходит в Дрездене",
    "eventsBody": "Вас ждут новые события.",
    "vibePlanTitle": "Ваш вайб создал план",
    "vibePlanBody": "Нажмите, чтобы посмотреть план и присоединиться.",
    "partnerUpdateTitle": "Новости от партнёра, на которого вы подписаны",
    "partnerUpdateBody": "Посмотрите, что нового.",
    "newFollowerTitle": "У вас новый подписчик 🧡",
    "newFollowerBody": "Кто-то подписался на вас в Tonyte.",
    "profilePhotoReminderTitle": "Заполните профиль Tonyte 👋",
    "profilePhotoReminderBody": "Добавьте фото профиля, чтобы открыть Планы и Vibes.",
    "appUpdateReminderTitle": "Вас ждёт лучший Tonyte 🧡",
    "appUpdateReminderBody": "Обновите Tonyte, чтобы получить новые функции, исправления и улучшения."
  },
  "vibeClaim": {
    "playedOnWeb": "Играли в Vibe на сайте?",
    "enterCodeTitle": "Добавьте ответы с сайта",
    "enterCodeBody": "Введите код, показанный в конце игры Vibe на tonyte.app.",
    "continue": "Продолжить",
    "ok": "OK",
    "invalidFormat": "Код выглядит так: ABCD-EFGH.",
    "invalidCode": "Такого кода нет, или срок его действия истёк.",
    "oldRoundCode": "Этот код относится к прошлому раунду, который уже закрыт.",
    "alreadyClaimedCode": "Эти ответы уже добавлены в аккаунт Tonyte.",
    "savedSignIn": "Готово! Войдите или создайте аккаунт — и мы добавим ваши ответы.",
    "networkError": "Не удалось проверить код. Проверьте подключение и попробуйте снова.",
    "rateLimited": "Слишком много попыток. Подождите несколько минут.",
    "waitingBanner": "Ваши ответы Vibe с сайта ждут вас. Войдите или зарегистрируйтесь, чтобы увидеть свои вайбы.",
    "discard": "Удалить ответы с сайта",
    "addedToast": "Ваши ответы с сайта добавлены ✨",
    "unlocksAt13": "Первые вайбы откроются в 13:00.",
    "alreadyPlayedTodayTitle": "Вы уже сыграли в сегодняшний Vibe",
    "alreadyPlayedTodayBody": "Ваши ответы за сегодня уже учтены. Каждый аккаунт играет один раз в день, поэтому код с сайта добавить нельзя. Новый раунд начнётся завтра в 6:00.",
    "addingTitle": "Добавляем ответы с сайта…",
    "addingBody": "Мы добавляем ответы по введённому коду. Это займёт всего мгновение.",
    "notOpenTitle": "Сегодняшняя игра ещё не открыта",
    "notOpenBody": "Игра Vibe открывается в 6:00. Коды действуют только в день игры.",
    "seeMyVibes": "Мои вайбы",
    "alreadyPlayedTitle": "Вы уже играли сегодня",
    "alreadyPlayedBody": "Вы уже ответили на сегодняшние вопросы Vibe в приложении, поэтому мы оставили эти ответы. После отправки ответы фиксируются, так что ответы с сайта не использованы.",
    "roundClosedTitle": "Эти ответы были за {date}",
    "roundClosedBody": "Ответы с сайта учитываются только в том раунде, в котором вы играли, а он уже закрыт. Сегодняшние вопросы ждут вас в Day Vibes.",
    "playToday": "Играть сегодня",
    "claimedElsewhereTitle": "Уже в другом аккаунте",
    "claimedElsewhereBody": "Эти ответы добавлены в другой аккаунт Tonyte. Каждый набор ответов может принадлежать только одному аккаунту.",
    "notFoundTitle": "Не удалось добавить ответы",
    "notFoundBody": "Ссылка или код устарели или недействительны. Ответы с сайта можно добавить до полуночи (по берлинскому времени) в день игры.",
    "notEligibleBody": "Day Vibes недоступен для этого типа аккаунта.",
    "emailFoundTitle": "Добавить ответы с сайта?",
    "emailFoundBody": "Вы сохранили сегодняшние ответы Vibe на tonyte.app с адресом {email}. Добавить их в этот аккаунт?",
    "addAnswers": "Добавить",
    "notNow": "Не сейчас"
  },
  partnerCommunity: {
    button: 'Community chat',
    followToJoinTitle: 'Follow to join?',
    followToJoinBody: 'Follow {name} to join their community chat.',
    followAndJoin: 'Follow & join',
    signIn: 'Sign in to join this partner’s community. You’ll return here afterward.',
    signInAction: 'Sign in',
    joinFailed: 'Couldn’t join the community. Please try again.',
    unfollowTitle: 'Unfollow and leave community?',
    unfollowBody: 'Unfollowing {name} also removes you from their community chat.',
    unfollowAndLeave: 'Unfollow & leave',
    messagesTab: 'Messages',
    notificationsTab: 'Notifications',
    communitiesTab: 'Community Chats',
    incoming: 'Incoming requests',
    outgoing: 'Outgoing requests',
    emptyTitle: 'Find your communities',
    emptyBody: 'Follow a partner and join their community to chat with people around it.',
    discover: 'Discover partners',
    about: 'The official member chat for this partner.',
    memberOnly: 'Followers’ community',
    leaveConfirm: 'Leave this community chat? You will keep following the partner.',
    ownerCannotLeave: 'You administer this community as the partner owner.',
    accessRemoved: 'You no longer have access to this community.',
    allowBack: 'Allow back',
    allowedBack: 'This person can rejoin after following the partner.',
    rejoined: 'Member reinstated.',
    descriptionPlaceholder: 'Добавьте описание сообщества…',
    descriptionSaved: 'Описание сообщества обновлено.',
    descriptionSaveFailed: 'Не удалось обновить описание.',
    admin: 'Админ',
    coAdmin: 'Со-админ',
    makeCoAdmin: 'Назначить со-админом',
    removeCoAdmin: 'Убрать роль со-админа',
    coAdminAdded: '{name} теперь со-админ.',
    coAdminRemoved: '{name} больше не со-админ.',
  },
  "partnerReviews": {
    "tab": "Отзывы",
    "reviewCount_one": "{count} отзыв",
    "reviewCount_few": "{count} отзыва",
    "reviewCount_many": "{count} отзывов",
    "reviewCount_other": "{count} отзыва",
    "ratingCount_one": "{count} оценка",
    "ratingCount_few": "{count} оценки",
    "ratingCount_many": "{count} оценок",
    "ratingCount_other": "{count} оценки",
    "starCount_one": "{count} звезда",
    "starCount_few": "{count} звезды",
    "starCount_many": "{count} звёзд",
    "starCount_other": "{count} звезды",
    "noReviewsYet": "Пока нет отзывов",
    "beFirst": "Будьте первыми",
    "summaryA11y": "Оценка {avg} из 5 по {count} отзывам. Показать отзывы",
    "write": "Написать отзыв",
    "edit": "Изменить отзыв",
    "ownProfile": "Отзывы оставляют посетители — свой профиль оценить нельзя.",
    "signInToReview": "Войдите или зарегистрируйтесь, чтобы написать отзыв.",
    "filterAll": "Все",
    "empty": "Пока нет отзывов",
    "emptySub": "Были здесь? Расскажите, как всё прошло, и помогите другим.",
    "emptyFiltered": "Пока нет отзывов с оценкой {count}.",
    "loadFailed": "Не удалось загрузить отзывы.",
    "retry": "Повторить",
    "showMore": "Показать ещё отзывы",
    "edited": "Изменён",
    "readMore": "Читать дальше",
    "showLess": "Свернуть",
    "yourReview": "Ваш отзыв",
    "hiddenNotice": "Этот отзыв видите только вы, пока наша команда его проверяет.",
    "removedNotice": "Модераторы удалили этот отзыв. Вы можете удалить его и написать новый.",
    "menu": "Действия с отзывом",
    "titleNew": "Оценить {name}",
    "titleEdit": "Изменить отзыв",
    "aboutPartner": "Вы оцениваете {name} в целом, а не отдельное событие.",
    "draftRestored": "Мы сохранили ваш незаконченный отзыв.",
    "ratingLabel": "Ваша оценка",
    "tapToRate": "Нажмите на звезду",
    "ratingRequired": "Выберите оценку, чтобы продолжить.",
    "textLabel": "Ваш отзыв (необязательно)",
    "placeholder": "Как всё прошло? Атмосфера, люди, события…",
    "submit": "Опубликовать",
    "update": "Сохранить",
    "posted": "Спасибо за отзыв!",
    "updated": "Отзыв обновлён",
    "deleted": "Отзыв удалён",
    "deleteTitle": "Удалить отзыв?",
    "deleteBody": "Ваша оценка и текст будут удалены из профиля {name}.",
    "ratingWords": {
      "1": "Не моё",
      "2": "Могло быть лучше",
      "3": "Нормально",
      "4": "Очень хорошо",
      "5": "В восторге"
    },
    "actions": {
      "edit": "Изменить отзыв",
      "delete": "Удалить отзыв",
      "report": "Пожаловаться",
      "hide": "Скрыть отзыв (админ)",
      "restore": "Восстановить отзыв (админ)",
      "remove": "Удалить отзыв (админ)",
      "dismiss": "Закрыть жалобы"
    },
    "confirm": {
      "hideTitle": "Скрыть этот отзыв?",
      "hideBody": "Он исчезнет из профиля и не будет учитываться в рейтинге, пока его не восстановят.",
      "removeTitle": "Удалить этот отзыв?",
      "removeBody": "Текст будет стёрт, и отзыв перестанет учитываться в рейтинге. Это нельзя отменить.",
      "dismissTitle": "Закрыть эти жалобы?",
      "dismissBody": "Отзыв останется видимым, жалобы будут закрыты."
    },
    "moderated": {
      "hide": "Отзыв скрыт",
      "restore": "Отзыв восстановлен",
      "remove": "Отзыв удалён",
      "dismiss": "Жалобы закрыты"
    },
    "reportTitle": "Пожаловаться на отзыв",
    "reportReason": "Почему вы жалуетесь?",
    "reasons": {
      "spam": "Спам или реклама",
      "harassment": "Оскорбления или ненависть",
      "inappropriate": "Неприемлемый контент",
      "fake": "Фейк или обман",
      "other": "Другое"
    },
    "reportDetails": "Что-то ещё? (необязательно)",
    "reportSubmit": "Отправить жалобу",
    "reported": "Спасибо — наша команда посмотрит.",
    "errors": {
      "signIn": "Войдите снова, чтобы опубликовать отзыв. Черновик сохранён.",
      "verifyEmail": "Подтвердите e-mail, чтобы публиковать отзывы. Черновик сохранён.",
      "ownProfile": "Нельзя оценить собственный профиль.",
      "removed": "Этот отзыв удалён модераторами, его нельзя изменить.",
      "rating": "Выберите оценку от 1 до 5 звёзд.",
      "tooLong": "Отзыв может содержать не более 1000 символов.",
      "unavailable": "Этот профиль недоступен.",
      "reviewGone": "Этот отзыв больше недоступен.",
      "ownReview": "Нельзя пожаловаться на свой отзыв.",
      "access": "Ваш аккаунт сейчас не может публиковать отзывы.",
      "network": "Проблема с подключением — попробуйте ещё раз. Черновик сохранён.",
      "generic": "Что-то пошло не так. Попробуйте ещё раз."
    },
    "admin": {
      "title": "Жалобы на отзывы",
      "profileSub": "Скрыть или удалить отзывы о партнёрах",
      "open": "Открытые",
      "resolved": "Решённые",
      "empty": "Жалоб на отзывы нет.",
      "reason": "Причина",
      "details": "Подробности",
      "reportedAt": "Жалоба от {date}",
      "currentStatus": "Сейчас",
      "status": {
        "published": "Виден",
        "hidden": "Скрыт",
        "removed": "Удалён",
        "missing": "Удалён автором"
      },
      "resolution": {
        "hidden": "Скрыт",
        "removed": "Удалён",
        "dismissed": "Закрыта",
        "review_deleted": "Удалён автором",
        "restored": "Восстановлен"
      },
      "openProfile": "Открыть профиль",
      "loadFailed": "Не удалось загрузить жалобы."
    }
  }
};
